const BobRossPaintingsData = [
	{
		title: 'A Walk in the Woods',
		img_src: 'https://www.twoinchbrush.com/images/painting282.png',
		img_src_index: 282,
		youtube_src: 'https://www.youtube.com/embed/oh5p5f5_-7A',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 1,
	},
	{
		title: 'Mt. McKinley',
		img_src: 'https://www.twoinchbrush.com/images/painting283.png',
		img_src_index: 283,
		youtube_src: 'https://www.youtube.com/embed/RInDWhYceLU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 2,
	},
	{
		title: 'Ebony Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting284.png',
		img_src_index: 284,
		youtube_src: 'https://www.youtube.com/embed/UOziR7PoVco',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 3,
	},
	{
		title: 'Winter Mist',
		img_src: 'https://www.twoinchbrush.com/images/painting285.png',
		img_src_index: 285,
		youtube_src: 'https://www.youtube.com/embed/0pwoixRikn4',
		color_name: ['Prussian Blue', 'Titanium White', 'Van Dyke Brown'],
		color_hex: ['#021E44', '#FFFFFF', '#221B15'],
		season: 1,
		episode: 4,
	},
	{
		title: 'Quiet Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting286.png',
		img_src_index: 286,
		youtube_src: 'https://www.youtube.com/embed/DFSIQNjKRfk',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 5,
	},
	{
		title: 'Winter Moon',
		img_src: 'https://www.twoinchbrush.com/images/painting287.png',
		img_src_index: 287,
		youtube_src: 'https://www.youtube.com/embed/loAzRUzx1wI',
		color_name: ['Black Gesso', 'Prussian Blue', 'Titanium White', 'Van Dyke Brown'],
		color_hex: ['#000000', '#021E44', '#FFFFFF', '#221B15'],
		season: 1,
		episode: 6,
	},
	{
		title: 'Autumn Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting288.png',
		img_src_index: 288,
		youtube_src: 'https://www.youtube.com/embed/sDdpc8uisD0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 7,
	},
	{
		title: 'Peaceful Valley',
		img_src: 'https://www.twoinchbrush.com/images/painting289.png',
		img_src_index: 289,
		youtube_src: 'https://www.youtube.com/embed/kQlFwTOkYzg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 8,
	},
	{
		title: 'Seascape',
		img_src: 'https://www.twoinchbrush.com/images/painting290.png',
		img_src_index: 290,
		youtube_src: 'https://www.youtube.com/embed/QxcS7p1VHyQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 9,
	},
	{
		title: 'Mountain Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting291.png',
		img_src_index: 291,
		youtube_src: 'https://www.youtube.com/embed/wDnLlywAL5I',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 10,
	},
	{
		title: 'Winter Glow',
		img_src: 'https://www.twoinchbrush.com/images/painting292.png',
		img_src_index: 292,
		youtube_src: 'https://www.youtube.com/embed/Q03YvknOVe0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 11,
	},
	{
		title: 'Snow Fall',
		img_src: 'https://www.twoinchbrush.com/images/painting293.png',
		img_src_index: 293,
		youtube_src: 'https://www.youtube.com/embed/4E35-8x_y04',
		color_name: ['Alizarin Crimson', 'Prussian Blue', 'Titanium White', 'Van Dyke Brown'],
		color_hex: ['#4E1500', '#021E44', '#FFFFFF', '#221B15'],
		season: 1,
		episode: 12,
	},
	{
		title: 'Final Reflections',
		img_src: 'https://www.twoinchbrush.com/images/painting294.png',
		img_src_index: 294,
		youtube_src: 'https://www.youtube.com/embed/IEQWfszfRlA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 1,
		episode: 13,
	},
	{
		title: 'Meadow Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting269.png',
		img_src_index: 269,
		youtube_src: 'https://www.youtube.com/embed/GARWowi0QXI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 1,
	},
	{
		title: 'Winter Sun',
		img_src: 'https://www.twoinchbrush.com/images/painting270.png',
		img_src_index: 270,
		youtube_src: 'https://www.youtube.com/embed/VPfYRj4DDco',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 2,
	},
	{
		title: 'Ebony Sea',
		img_src: 'https://www.twoinchbrush.com/images/painting271.png',
		img_src_index: 271,
		youtube_src: 'https://www.youtube.com/embed/aOJsKNzO3i8',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 3,
	},
	{
		title: 'Shades of Grey',
		img_src: 'https://www.twoinchbrush.com/images/painting272.png',
		img_src_index: 272,
		youtube_src: 'https://www.youtube.com/embed/I-ousb8-SD0',
		color_name: ['Prussian Blue', 'Titanium White', 'Van Dyke Brown'],
		color_hex: ['#021E44', '#FFFFFF', '#221B15'],
		season: 2,
		episode: 4,
	},
	{
		title: 'Autumn Splendor',
		img_src: 'https://www.twoinchbrush.com/images/painting273.png',
		img_src_index: 273,
		youtube_src: 'https://www.youtube.com/embed/rTTWw5Gd79I',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 5,
	},
	{
		title: 'Black River',
		img_src: 'https://www.twoinchbrush.com/images/painting274.png',
		img_src_index: 274,
		youtube_src: 'https://www.youtube.com/embed/6O4sfJd8G_M',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 6,
	},
	{
		title: 'Brown Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting275.png',
		img_src_index: 275,
		youtube_src: 'https://www.youtube.com/embed/Vx6v47gHBWM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 7,
	},
	{
		title: 'Reflections',
		img_src: 'https://www.twoinchbrush.com/images/painting276.png',
		img_src_index: 276,
		youtube_src: 'https://www.youtube.com/embed/0FYfo94qefg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 8,
	},
	{
		title: 'Black and White Seascape',
		img_src: 'https://www.twoinchbrush.com/images/painting277.png',
		img_src_index: 277,
		youtube_src: 'https://www.youtube.com/embed/PMDyPrE0puo',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 9,
	},
	{
		title: 'Lazy River',
		img_src: 'https://www.twoinchbrush.com/images/painting278.png',
		img_src_index: 278,
		youtube_src: 'https://www.youtube.com/embed/BW2wKKFvH1g',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 10,
	},
	{
		title: 'Black Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting279.png',
		img_src_index: 279,
		youtube_src: 'https://www.youtube.com/embed/GzSqjyQUPZQ',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 11,
	},
	{
		title: 'Mountain Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting280.png',
		img_src_index: 280,
		youtube_src: 'https://www.youtube.com/embed/9jIt95PCFAA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 12,
	},
	{
		title: 'Final Grace',
		img_src: 'https://www.twoinchbrush.com/images/painting281.png',
		img_src_index: 281,
		youtube_src: 'https://www.youtube.com/embed/miJ19Kz_i3Y',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 2,
		episode: 13,
	},
	{
		title: 'Mountain Retreat',
		img_src: 'https://www.twoinchbrush.com/images/painting256.png',
		img_src_index: 256,
		youtube_src: 'https://www.youtube.com/embed/hoimk4s8JoQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 1,
	},
	{
		title: 'Blue Moon',
		img_src: 'https://www.twoinchbrush.com/images/painting257.png',
		img_src_index: 257,
		youtube_src: 'https://www.youtube.com/embed/loit61vLUMc',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 2,
	},
	{
		title: 'Bubbling Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting258.png',
		img_src_index: 258,
		youtube_src: 'https://www.youtube.com/embed/fuFalEXVN0k',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 3,
	},
	{
		title: 'Winter Night',
		img_src: 'https://www.twoinchbrush.com/images/painting259.png',
		img_src_index: 259,
		youtube_src: 'https://www.youtube.com/embed/8ysFkNYwhAE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Liquid Black',
			'Phthalo Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#DB0000', '#FFEC00', '#000000', '#102E3C', '#FFFFFF', '#221B15'],
		season: 3,
		episode: 4,
	},
	{
		title: 'Distant Hills',
		img_src: 'https://www.twoinchbrush.com/images/painting260.png',
		img_src_index: 260,
		youtube_src: 'https://www.youtube.com/embed/8Zge88tVwjE',
		color_name: [
			'Alizarin Crimson',
			'Burnt Umber',
			'Cadmium Yellow',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: ['#4E1500', '#8A3324', '#FFEC00', '#0A3410', '#FFFFFF', '#221B15', '#C79B00'],
		season: 3,
		episode: 5,
	},
	{
		title: 'Covered Bridge',
		img_src: 'https://www.twoinchbrush.com/images/painting261.png',
		img_src_index: 261,
		youtube_src: 'https://www.youtube.com/embed/OHSm8kLE7js',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 6,
	},
	{
		title: 'Quiet Inlet',
		img_src: 'https://www.twoinchbrush.com/images/painting262.png',
		img_src_index: 262,
		youtube_src: 'https://www.youtube.com/embed/9N5IWKzYIyU',
		color_name: [
			'Alizarin Crimson',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#8A3324',
			'#FFEC00',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 7,
	},
	{
		title: 'Night Light',
		img_src: 'https://www.twoinchbrush.com/images/painting263.png',
		img_src_index: 263,
		youtube_src: 'https://www.youtube.com/embed/l141Y0x8om0',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#8A3324',
			'#FFEC00',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 8,
	},
	{
		title: 'The Old Mill',
		img_src: 'https://www.twoinchbrush.com/images/painting264.png',
		img_src_index: 264,
		youtube_src: 'https://www.youtube.com/embed/OFKFUJ9eDNs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 9,
	},
	{
		title: 'Campfire',
		img_src: 'https://www.twoinchbrush.com/images/painting265.png',
		img_src_index: 265,
		youtube_src: 'https://www.youtube.com/embed/L5bXkI0-pEg',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 10,
	},
	{
		title: 'Rustic Barn',
		img_src: 'https://www.twoinchbrush.com/images/painting266.png',
		img_src_index: 266,
		youtube_src: 'https://www.youtube.com/embed/WJJwrnFhUUg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 11,
	},
	{
		title: 'Hidden Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting267.png',
		img_src_index: 267,
		youtube_src: 'https://www.youtube.com/embed/P_DaqkFbnac',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 12,
	},
	{
		title: 'Peaceful Waters',
		img_src: 'https://www.twoinchbrush.com/images/painting268.png',
		img_src_index: 268,
		youtube_src: 'https://www.youtube.com/embed/Z0vtjRLqXcQ',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 3,
		episode: 13,
	},
	{
		title: 'Purple Splendor',
		img_src: 'https://www.twoinchbrush.com/images/painting243.png',
		img_src_index: 243,
		youtube_src: 'https://www.youtube.com/embed/hP4GfMgsNVE',
		color_name: ['Alizarin Crimson', 'Phthalo Blue', 'Titanium White', 'Van Dyke Brown'],
		color_hex: ['#4E1500', '#0C0040', '#FFFFFF', '#221B15'],
		season: 4,
		episode: 1,
	},
	{
		title: 'Tranquil Valley',
		img_src: 'https://www.twoinchbrush.com/images/painting244.png',
		img_src_index: 244,
		youtube_src: 'https://www.youtube.com/embed/PbchoOWWCZs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 2,
	},
	{
		title: 'Majestic Mountains',
		img_src: 'https://www.twoinchbrush.com/images/painting245.png',
		img_src_index: 245,
		youtube_src: 'https://www.youtube.com/embed/NcVeRlPu_5w',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 3,
	},
	{
		title: 'Winter Sawscape',
		img_src: 'https://www.twoinchbrush.com/images/painting246.png',
		img_src_index: 246,
		youtube_src: 'https://www.youtube.com/embed/lmKAwKrONmE',
		color_name: [
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
		],
		color_hex: ['#000000', '#DB0000', '#8A3324', '#FFEC00', '#000000', '#021E44', '#FFFFFF'],
		season: 4,
		episode: 4,
	},
	{
		title: 'Evening Seascape',
		img_src: 'https://www.twoinchbrush.com/images/painting247.png',
		img_src_index: 247,
		youtube_src: 'https://www.youtube.com/embed/y5k4GXw_-yI',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 4,
		episode: 5,
	},
	{
		title: 'Warm Summer Day',
		img_src: 'https://www.twoinchbrush.com/images/painting248.png',
		img_src_index: 248,
		youtube_src: 'https://www.youtube.com/embed/GBN9AIw3Ao4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 6,
	},
	{
		title: 'Cabin in the Woods',
		img_src: 'https://www.twoinchbrush.com/images/painting249.png',
		img_src_index: 249,
		youtube_src: 'https://www.youtube.com/embed/81QKellPA70',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 7,
	},
	{
		title: 'Wetlands',
		img_src: 'https://www.twoinchbrush.com/images/painting250.png',
		img_src_index: 250,
		youtube_src: 'https://www.youtube.com/embed/2FpVyGanPwM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 8,
	},
	{
		title: 'Cool Waters',
		img_src: 'https://www.twoinchbrush.com/images/painting251.png',
		img_src_index: 251,
		youtube_src: 'https://www.youtube.com/embed/tJRvBcqQd5A',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 9,
	},
	{
		title: 'Quiet Woods',
		img_src: 'https://www.twoinchbrush.com/images/painting252.png',
		img_src_index: 252,
		youtube_src: 'https://www.youtube.com/embed/wIZX57I4aDs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 10,
	},
	{
		title: 'Northwest Majesty',
		img_src: 'https://www.twoinchbrush.com/images/painting253.png',
		img_src_index: 253,
		youtube_src: 'https://www.youtube.com/embed/9DU6bunvD_g',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Liquid Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 4,
		episode: 11,
	},
	{
		title: 'Autumn Days',
		img_src: 'https://www.twoinchbrush.com/images/painting254.png',
		img_src_index: 254,
		youtube_src: 'https://www.youtube.com/embed/VAdMkf-AAPM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 12,
	},
	{
		title: 'Mountain Challenge',
		img_src: 'https://www.twoinchbrush.com/images/painting255.png',
		img_src_index: 255,
		youtube_src: 'https://www.youtube.com/embed/o2cjLA_wgIk',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 4,
		episode: 13,
	},
	{
		title: 'Mountain Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting230.png',
		img_src_index: 230,
		youtube_src: 'https://www.youtube.com/embed/DqhzxdkdQS0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 5,
		episode: 1,
	},
	{
		title: 'Twilight Meadow',
		img_src: 'https://www.twoinchbrush.com/images/painting231.png',
		img_src_index: 231,
		youtube_src: 'https://www.youtube.com/embed/6evqNlOO7Bw',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 5,
		episode: 2,
	},
	{
		title: 'Mountain Blossoms',
		img_src: 'https://www.twoinchbrush.com/images/painting232.png',
		img_src_index: 232,
		youtube_src: 'https://www.youtube.com/embed/UVhhStJAJZc',
		color_name: [
			'Alizarin Crimson',
			'Liquid Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
		],
		color_hex: ['#4E1500', '#000000', '#0C0040', '#102E3C', '#FFFFFF'],
		season: 5,
		episode: 3,
	},
	{
		title: 'Winter Stillness',
		img_src: 'https://www.twoinchbrush.com/images/painting233.png',
		img_src_index: 233,
		youtube_src: 'https://www.youtube.com/embed/qg9c1SqdRko',
		color_name: [
			'Alizarin Crimson',
			'Burnt Umber',
			'Indian Yellow',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#8A3324', '#FFB800', '#0C0040', '#0A3410', '#FFFFFF', '#221B15'],
		season: 5,
		episode: 4,
	},
	{
		title: 'Quiet Pond',
		img_src: 'https://www.twoinchbrush.com/images/painting234.png',
		img_src_index: 234,
		youtube_src: 'https://www.youtube.com/embed/aiK9xOIJtV8',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 5,
		episode: 5,
	},
	{
		title: 'Ocean Sunrise',
		img_src: 'https://www.twoinchbrush.com/images/painting235.png',
		img_src_index: 235,
		youtube_src: 'https://www.youtube.com/embed/u0Bz6TNUK1Q',
		color_name: [
			'Alizarin Crimson',
			'Indian Yellow',
			'Liquid Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#FFB800', '#000000', '#021E44', '#FFFFFF', '#221B15'],
		season: 5,
		episode: 6,
	},
	{
		title: 'Bubbling Brook',
		img_src: 'https://www.twoinchbrush.com/images/painting236.png',
		img_src_index: 236,
		youtube_src: 'https://www.youtube.com/embed/LiKCzeqn-kg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 5,
		episode: 7,
	},
	{
		title: 'Arizona Splendor',
		img_src: 'https://www.twoinchbrush.com/images/painting237.png',
		img_src_index: 237,
		youtube_src: 'https://www.youtube.com/embed/spFwCh2616s',
		color_name: [
			'Alizarin Crimson',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 5,
		episode: 8,
	},
	{
		title: 'Anatomy of a Wave',
		img_src: 'https://www.twoinchbrush.com/images/painting238.png',
		img_src_index: 238,
		youtube_src: 'https://www.youtube.com/embed/DFQlu6eqrBo',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Liquid Clear',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
		],
		color_hex: ['#4E1500', '#FFEC00', '#FFFFFF', '#0C0040', '#102E3C', '#FFFFFF'],
		season: 5,
		episode: 9,
	},
	{
		title: 'The Windmill',
		img_src: 'https://www.twoinchbrush.com/images/painting239.png',
		img_src_index: 239,
		youtube_src: 'https://www.youtube.com/embed/xj8xsTSkbUk',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#8A3324',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 5,
		episode: 10,
	},
	{
		title: 'Autumn Glory',
		img_src: 'https://www.twoinchbrush.com/images/painting240.png',
		img_src_index: 240,
		youtube_src: 'https://www.youtube.com/embed/yTzlm_t0RmY',
		color_name: [
			'Alizarin Crimson',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 5,
		episode: 11,
	},
	{
		title: 'Indian Girl',
		img_src: 'https://www.twoinchbrush.com/images/painting241.png',
		img_src_index: 241,
		youtube_src: 'https://www.youtube.com/embed/2uXMx8Kjs8I',
		color_name: ['Bright Red', 'Burnt Umber', 'Indian Yellow', 'Prussian Blue', 'Titanium White'],
		color_hex: ['#DB0000', '#8A3324', '#FFB800', '#021E44', '#FFFFFF'],
		season: 5,
		episode: 12,
	},
	{
		title: 'Meadow Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting242.png',
		img_src_index: 242,
		youtube_src: 'https://www.youtube.com/embed/87MMbN1bQCs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 5,
		episode: 13,
	},
	{
		title: 'Blue River',
		img_src: 'https://www.twoinchbrush.com/images/painting217.png',
		img_src_index: 217,
		youtube_src: 'https://www.youtube.com/embed/LygUyAb78oY',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 1,
	},
	{
		title: "Nature's Edge",
		img_src: 'https://www.twoinchbrush.com/images/painting218.png',
		img_src_index: 218,
		youtube_src: 'https://www.youtube.com/embed/Bcqyzo85A1o',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 2,
	},
	{
		title: 'Morning Mist',
		img_src: 'https://www.twoinchbrush.com/images/painting219.png',
		img_src_index: 219,
		youtube_src: 'https://www.youtube.com/embed/wbZreRaE74k',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 3,
	},
	{
		title: 'Whispering Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting220.png',
		img_src_index: 220,
		youtube_src: 'https://www.youtube.com/embed/QglIjlqsUdU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 4,
	},
	{
		title: 'Secluded Forest',
		img_src: 'https://www.twoinchbrush.com/images/painting221.png',
		img_src_index: 221,
		youtube_src: 'https://www.youtube.com/embed/USkduOfwJok',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 5,
	},
	{
		title: 'Snow Trail',
		img_src: 'https://www.twoinchbrush.com/images/painting222.png',
		img_src_index: 222,
		youtube_src: 'https://www.youtube.com/embed/n9EsFFtwZnE',
		color_name: [
			'Alizarin Crimson',
			'Burnt Umber',
			'Cadmium Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#8A3324',
			'#FFEC00',
			'#0C0040',
			'#102E3C',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 6,
	},
	{
		title: 'Arctic Beauty',
		img_src: 'https://www.twoinchbrush.com/images/painting223.png',
		img_src_index: 223,
		youtube_src: 'https://www.youtube.com/embed/UQ-RTZCOQn0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 7,
	},
	{
		title: 'Horizons West',
		img_src: 'https://www.twoinchbrush.com/images/painting224.png',
		img_src_index: 224,
		youtube_src: 'https://www.youtube.com/embed/m6UM-rN2D6s',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#DB0000', '#FFEC00', '#FFB800', '#021E44', '#FFFFFF', '#221B15'],
		season: 6,
		episode: 8,
	},
	{
		title: 'High Chateau',
		img_src: 'https://www.twoinchbrush.com/images/painting225.png',
		img_src_index: 225,
		youtube_src: 'https://www.youtube.com/embed/dafH8ks9Zww',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 9,
	},
	{
		title: 'Country Life',
		img_src: 'https://www.twoinchbrush.com/images/painting226.png',
		img_src_index: 226,
		youtube_src: 'https://www.youtube.com/embed/j8Jf7QVKLgQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 10,
	},
	{
		title: 'Western Expanse',
		img_src: 'https://www.twoinchbrush.com/images/painting227.png',
		img_src_index: 227,
		youtube_src: 'https://www.youtube.com/embed/MTInkV5ODjk',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 11,
	},
	{
		title: 'Marshlands',
		img_src: 'https://www.twoinchbrush.com/images/painting228.png',
		img_src_index: 228,
		youtube_src: 'https://www.youtube.com/embed/Ugiwi8uizpg',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 12,
	},
	{
		title: 'Blaze of Color',
		img_src: 'https://www.twoinchbrush.com/images/painting229.png',
		img_src_index: 229,
		youtube_src: 'https://www.youtube.com/embed/se7wOprxRGs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Burnt Umber',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#8A3324',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 6,
		episode: 13,
	},
	{
		title: 'Winter Cabin',
		img_src: 'https://www.twoinchbrush.com/images/painting203.png',
		img_src_index: 203,
		youtube_src: 'https://www.youtube.com/embed/kdlHV6ceI_gw',
		color_name: [
			'Bright Red',
			'Dark Sienna',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: ['#DB0000', '#5F2E1F', '#021E44', '#FFFFFF', '#221B15', '#C79B00'],
		season: 7,
		episode: 1,
	},
	{
		title: 'Secluded Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting204.png',
		img_src_index: 204,
		youtube_src: 'https://www.youtube.com/embed/2OxSJcFvpoU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 2,
	},
	{
		title: 'Evergreens at Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting205.png',
		img_src_index: 205,
		youtube_src: 'https://www.youtube.com/embed/YQPEy3hYGo8',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Sap Green',
			'Titanium White',
		],
		color_hex: ['#4E1500', '#DB0000', '#FFEC00', '#FFB800', '#000000', '#0A3410', '#FFFFFF'],
		season: 7,
		episode: 3,
	},
	{
		title: 'Mountain Cabin',
		img_src: 'https://www.twoinchbrush.com/images/painting206.png',
		img_src_index: 206,
		youtube_src: 'https://www.youtube.com/embed/E3IAMvO8GyM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 4,
	},
	{
		title: 'Portrait of Sally',
		img_src: 'https://www.twoinchbrush.com/images/painting208.png',
		img_src_index: 208,
		youtube_src: 'https://www.youtube.com/embed/MHJB0IBnuD4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Phthalo Blue',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#0C0040',
			'#FFFFFF',
			'#C79B00',
		],
		season: 7,
		episode: 5,
	},
	{
		title: 'Misty Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting209.png',
		img_src_index: 209,
		youtube_src: 'https://www.youtube.com/embed/530_cVmexiI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 6,
	},
	{
		title: 'Barn at Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting210.png',
		img_src_index: 210,
		youtube_src: 'https://www.youtube.com/embed/WT6n0K2zGnA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 7,
	},
	{
		title: 'Mountain Splendor',
		img_src: 'https://www.twoinchbrush.com/images/painting211.png',
		img_src_index: 211,
		youtube_src: 'https://www.youtube.com/embed/GhOGZMpPUSE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 8,
	},
	{
		title: 'Lake by Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting212.png',
		img_src_index: 212,
		youtube_src: 'https://www.youtube.com/embed/yAiYirlcq7o',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 9,
	},
	{
		title: 'Mountain Glory',
		img_src: 'https://www.twoinchbrush.com/images/painting213.png',
		img_src_index: 213,
		youtube_src: 'https://www.youtube.com/embed/0M9pwLHRR2c',
		color_name: [
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 10,
	},
	{
		title: 'Grey Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting214.png',
		img_src_index: 214,
		youtube_src: 'https://www.youtube.com/embed/sS-hNYgDUak',
		color_name: ['Alizarin Crimson', 'Midnight Black', 'Titanium White'],
		color_hex: ['#4E1500', '#000000', '#FFFFFF'],
		season: 7,
		episode: 11,
	},
	{
		title: 'Dock Scene',
		img_src: 'https://www.twoinchbrush.com/images/painting215.png',
		img_src_index: 215,
		youtube_src: 'https://www.youtube.com/embed/4KYxkqlzyqM',
		color_name: [
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 12,
	},
	{
		title: 'Dark Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting216.png',
		img_src_index: 216,
		youtube_src: 'https://www.youtube.com/embed/VqMbL00eZqw',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 7,
		episode: 13,
	},
	{
		title: 'Misty Rolling Hills',
		img_src: 'https://www.twoinchbrush.com/images/painting190.png',
		img_src_index: 190,
		youtube_src: 'https://www.youtube.com/embed/cC5ozePVKGI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 1,
	},
	{
		title: 'Lakeside Cabin',
		img_src: 'https://www.twoinchbrush.com/images/painting191.png',
		img_src_index: 191,
		youtube_src: 'https://www.youtube.com/embed/CP6_5cQVZvQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 2,
	},
	{
		title: 'Warm Winter Day',
		img_src: 'https://www.twoinchbrush.com/images/painting192.png',
		img_src_index: 192,
		youtube_src: 'https://www.youtube.com/embed/mUJoNLWQ1yI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 3,
	},
	{
		title: 'Waterside Way',
		img_src: 'https://www.twoinchbrush.com/images/painting193.png',
		img_src_index: 193,
		youtube_src: 'https://www.youtube.com/embed/uj5FE70BcB0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 4,
	},
	{
		title: "Hunter's Haven",
		img_src: 'https://www.twoinchbrush.com/images/painting194.png',
		img_src_index: 194,
		youtube_src: 'https://www.youtube.com/embed/Da4SPyh1ATM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 5,
	},
	{
		title: 'Bubbling Mountain Brook',
		img_src: 'https://www.twoinchbrush.com/images/painting195.png',
		img_src_index: 195,
		youtube_src: 'https://www.youtube.com/embed/U2_SKgM3f4A',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 6,
	},
	{
		title: 'Winter Hideaway',
		img_src: 'https://www.twoinchbrush.com/images/painting196.png',
		img_src_index: 196,
		youtube_src: 'https://www.youtube.com/embed/19oz9XHZNzA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 7,
	},
	{
		title: 'Foot of the Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting197.png',
		img_src_index: 197,
		youtube_src: 'https://www.youtube.com/embed/cIUBUc_ITBc',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 8,
	},
	{
		title: 'Majestic Pine',
		img_src: 'https://www.twoinchbrush.com/images/painting198.png',
		img_src_index: 198,
		youtube_src: 'https://www.youtube.com/embed/x5CoQj9zr-c',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 9,
	},
	{
		title: 'Cactus at Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting199.png',
		img_src_index: 199,
		youtube_src: 'https://www.youtube.com/embed/XBqD3QhKU24',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 10,
	},
	{
		title: 'Mountain Range',
		img_src: 'https://www.twoinchbrush.com/images/painting200.png',
		img_src_index: 200,
		youtube_src: 'https://www.youtube.com/embed/V_l6olF3yHI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 11,
	},
	{
		title: 'Lonely Retreat',
		img_src: 'https://www.twoinchbrush.com/images/painting201.png',
		img_src_index: 201,
		youtube_src: 'https://www.youtube.com/embed/qTDQt_PdlYc',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 8,
		episode: 12,
	},
	{
		title: 'Northern Lights',
		img_src: 'https://www.twoinchbrush.com/images/painting202.png',
		img_src_index: 202,
		youtube_src: 'https://www.youtube.com/embed/vgbMONXc9Cs',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#FFFFFF',
			'#221B15',
		],
		season: 8,
		episode: 13,
	},
	{
		title: 'Winter Evergreens',
		img_src: 'https://www.twoinchbrush.com/images/painting177.png',
		img_src_index: 177,
		youtube_src: 'https://www.youtube.com/embed/O6L5YPt9CeU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 1,
	},
	{
		title: "Surf's Up",
		img_src: 'https://www.twoinchbrush.com/images/painting178.png',
		img_src_index: 178,
		youtube_src: 'https://www.youtube.com/embed/ZKxFvyyOBPQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 2,
	},
	{
		title: 'Red Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting179.png',
		img_src_index: 179,
		youtube_src: 'https://www.youtube.com/embed/e5JhYi_G-l0',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 3,
	},
	{
		title: 'Meadow Road',
		img_src: 'https://www.twoinchbrush.com/images/painting180.png',
		img_src_index: 180,
		youtube_src: 'https://www.youtube.com/embed/u5VT_WGM0kg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 4,
	},
	{
		title: 'Winter Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting181.png',
		img_src_index: 181,
		youtube_src: 'https://www.youtube.com/embed/pYWiLm_-sXw',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#DB0000', '#5F2E1F', '#000000', '#0C0040', '#FFFFFF', '#221B15'],
		season: 9,
		episode: 5,
	},
	{
		title: 'Secluded Beach',
		img_src: 'https://www.twoinchbrush.com/images/painting182.png',
		img_src_index: 182,
		youtube_src: 'https://www.youtube.com/embed/WGUcw_kFvzU',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 6,
	},
	{
		title: 'Forest Hills',
		img_src: 'https://www.twoinchbrush.com/images/painting183.png',
		img_src_index: 183,
		youtube_src: 'https://www.youtube.com/embed/E3XW_Zp238U',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 7,
	},
	{
		title: 'Little House by the Road',
		img_src: 'https://www.twoinchbrush.com/images/painting184.png',
		img_src_index: 184,
		youtube_src: 'https://www.youtube.com/embed/3CDg_9gL-5M',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 8,
	},
	{
		title: 'Mountain Path',
		img_src: 'https://www.twoinchbrush.com/images/painting185.png',
		img_src_index: 185,
		youtube_src: 'https://www.youtube.com/embed/e0VUprkc1n0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 9,
	},
	{
		title: 'Country Charm',
		img_src: 'https://www.twoinchbrush.com/images/painting186.png',
		img_src_index: 186,
		youtube_src: 'https://www.youtube.com/embed/9wp8NRzCJnw',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 10,
	},
	{
		title: "Nature's Paradise",
		img_src: 'https://www.twoinchbrush.com/images/painting187.png',
		img_src_index: 187,
		youtube_src: 'https://www.youtube.com/embed/7yU55PUls2c',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 11,
	},
	{
		title: 'Mountain by the Sea',
		img_src: 'https://www.twoinchbrush.com/images/painting188.png',
		img_src_index: 188,
		youtube_src: 'https://www.youtube.com/embed/so--opB-yuQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 12,
	},
	{
		title: 'Mountain Hideaway',
		img_src: 'https://www.twoinchbrush.com/images/painting189.png',
		img_src_index: 189,
		youtube_src: 'https://www.youtube.com/embed/q48EWPrbzVs',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 9,
		episode: 13,
	},
	{
		title: 'Towering Peaks',
		img_src: 'https://www.twoinchbrush.com/images/painting163.png',
		img_src_index: 163,
		youtube_src: 'https://www.youtube.com/embed/1s58rW0_LN4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 1,
	},
	{
		title: 'Cabin at Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting164.png',
		img_src_index: 164,
		youtube_src: 'https://www.youtube.com/embed/a6Wil3OXNuI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 2,
	},
	{
		title: 'Twin Falls',
		img_src: 'https://www.twoinchbrush.com/images/painting165.png',
		img_src_index: 165,
		youtube_src: 'https://www.youtube.com/embed/cMwkY8ojRik',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 3,
	},
	{
		title: 'Secluded Bridge',
		img_src: 'https://www.twoinchbrush.com/images/painting166.png',
		img_src_index: 166,
		youtube_src: 'https://www.youtube.com/embed/vrAMRxBB5KI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 4,
	},
	{
		title: 'Ocean Breeze',
		img_src: 'https://www.twoinchbrush.com/images/painting167.png',
		img_src_index: 167,
		youtube_src: 'https://www.youtube.com/embed/XZmdzfvXRuw',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 5,
	},
	{
		title: 'Autumn Woods',
		img_src: 'https://www.twoinchbrush.com/images/painting168.png',
		img_src_index: 168,
		youtube_src: 'https://www.youtube.com/embed/vKyMU5Z8cDI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 6,
	},
	{
		title: 'Winter Solitude',
		img_src: 'https://www.twoinchbrush.com/images/painting170.png',
		img_src_index: 170,
		youtube_src: 'https://www.youtube.com/embed/ov4YaCQB9co',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#DB0000', '#5F2E1F', '#000000', '#0C0040', '#FFFFFF', '#221B15'],
		season: 10,
		episode: 7,
	},
	{
		title: 'Golden Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting171.png',
		img_src_index: 171,
		youtube_src: 'https://www.youtube.com/embed/CiNDyckERXQ',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 8,
	},
	{
		title: 'Mountain Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting172.png',
		img_src_index: 172,
		youtube_src: 'https://www.youtube.com/embed/Qj6lMtnCt8o',
		color_name: [
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 9,
	},
	{
		title: 'Ocean Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting173.png',
		img_src_index: 173,
		youtube_src: 'https://www.youtube.com/embed/OJ_xqtvZf3o',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 10,
	},
	{
		title: 'Triple View',
		img_src: 'https://www.twoinchbrush.com/images/painting174.png',
		img_src_index: 174,
		youtube_src: 'https://www.youtube.com/embed/zoTeyliLn5o',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 11,
	},
	{
		title: 'Winter Frost',
		img_src: 'https://www.twoinchbrush.com/images/painting175.png',
		img_src_index: 175,
		youtube_src: 'https://www.youtube.com/embed/8satX-hLkuI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 10,
		episode: 12,
	},
	{
		title: 'Lakeside Cabin',
		img_src: 'https://www.twoinchbrush.com/images/painting176.png',
		img_src_index: 176,
		youtube_src: 'https://www.youtube.com/embed/1l_TsfCIb_I',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 10,
		episode: 13,
	},
	{
		title: 'Mountain Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting150.png',
		img_src_index: 150,
		youtube_src: 'https://www.youtube.com/embed/xdFCj6BzQio',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 1,
	},
	{
		title: 'Country Cabin',
		img_src: 'https://www.twoinchbrush.com/images/painting151.png',
		img_src_index: 151,
		youtube_src: 'https://www.youtube.com/embed/Dkww2nHpuZw',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#DB0000', '#5F2E1F', '#000000', '#021E44', '#FFFFFF', '#221B15'],
		season: 11,
		episode: 2,
	},
	{
		title: 'Daisy Delight',
		img_src: 'https://www.twoinchbrush.com/images/painting152.png',
		img_src_index: 152,
		youtube_src: 'https://www.youtube.com/embed/HuHC1RqtvDA',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 3,
	},
	{
		title: 'Hidden Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting153.png',
		img_src_index: 153,
		youtube_src: 'https://www.youtube.com/embed/JGzTg8fCj4w',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 4,
	},
	{
		title: 'Towering Glacier',
		img_src: 'https://www.twoinchbrush.com/images/painting154.png',
		img_src_index: 154,
		youtube_src: 'https://www.youtube.com/embed/67vdGbA3Xkg',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 5,
	},
	{
		title: 'Oval Barn',
		img_src: 'https://www.twoinchbrush.com/images/painting155.png',
		img_src_index: 155,
		youtube_src: 'https://www.youtube.com/embed/HqBhCibidNM',
		color_name: [
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#DB0000', '#5F2E1F', '#000000', '#021E44', '#FFFFFF', '#221B15'],
		season: 11,
		episode: 6,
	},
	{
		title: 'Lakeside Path',
		img_src: 'https://www.twoinchbrush.com/images/painting156.png',
		img_src_index: 156,
		youtube_src: 'https://www.youtube.com/embed/1yjGoJokbZg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 7,
	},
	{
		title: 'Sunset Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting157.png',
		img_src_index: 157,
		youtube_src: 'https://www.youtube.com/embed/9xG6IzcGotI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 8,
	},
	{
		title: 'Winter Barn',
		img_src: 'https://www.twoinchbrush.com/images/painting158.png',
		img_src_index: 158,
		youtube_src: 'https://www.youtube.com/embed/_xkn0ceDreo',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#FFFFFF', '#221B15'],
		season: 11,
		episode: 9,
	},
	{
		title: 'Sunset over the Waves',
		img_src: 'https://www.twoinchbrush.com/images/painting159.png',
		img_src_index: 159,
		youtube_src: 'https://www.youtube.com/embed/c4b_B2F1eZg',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
		],
		season: 11,
		episode: 10,
	},
	{
		title: 'Golden Glow',
		img_src: 'https://www.twoinchbrush.com/images/painting160.png',
		img_src_index: 160,
		youtube_src: 'https://www.youtube.com/embed/aA8RhtaWACA',
		color_name: [
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 11,
	},
	{
		title: 'Roadside Barn',
		img_src: 'https://www.twoinchbrush.com/images/painting161.png',
		img_src_index: 161,
		youtube_src: 'https://www.youtube.com/embed/vJpKhiXvXdA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 12,
	},
	{
		title: 'Happy Accident',
		img_src: 'https://www.twoinchbrush.com/images/painting162.png',
		img_src_index: 162,
		youtube_src: 'https://www.youtube.com/embed/Fw6odlNp7_8',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 11,
		episode: 13,
	},
	{
		title: 'Golden Knoll',
		img_src: 'https://www.twoinchbrush.com/images/painting137.png',
		img_src_index: 137,
		youtube_src: 'https://www.youtube.com/embed/-O0Bs65eN5w',
		color_name: [
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: ['#FFEC00', '#5F2E1F', '#FFB800', '#000000', '#FFFFFF', '#221B15', '#C79B00'],
		season: 12,
		episode: 1,
	},
	{
		title: 'Mountain Reflections',
		img_src: 'https://www.twoinchbrush.com/images/painting138.png',
		img_src_index: 138,
		youtube_src: 'https://www.youtube.com/embed/rzYpa4XGSnA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 2,
	},
	{
		title: 'Secluded Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting139.png',
		img_src_index: 139,
		youtube_src: 'https://www.youtube.com/embed/3PZabdohLso',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 3,
	},
	{
		title: 'Bright Autumn Trees',
		img_src: 'https://www.twoinchbrush.com/images/painting140.png',
		img_src_index: 140,
		youtube_src: 'https://www.youtube.com/embed/aR-C3h5zURM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Midnight Black',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#000000',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 4,
	},
	{
		title: 'Black Seascape',
		img_src: 'https://www.twoinchbrush.com/images/painting141.png',
		img_src_index: 141,
		youtube_src: 'https://www.youtube.com/embed/P_aCan4cBwc',
		color_name: [
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#FFFFFF',
			'#221B15',
		],
		season: 12,
		episode: 5,
	},
	{
		title: 'Steep Mountains',
		img_src: 'https://www.twoinchbrush.com/images/painting142.png',
		img_src_index: 142,
		youtube_src: 'https://www.youtube.com/embed/fRK8_ioYWw4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 6,
	},
	{
		title: 'Quiet Mountains River',
		img_src: 'https://www.twoinchbrush.com/images/painting143.png',
		img_src_index: 143,
		youtube_src: 'https://www.youtube.com/embed/Leiw-FtADZc',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 7,
	},
	{
		title: 'Evening Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting144.png',
		img_src_index: 144,
		youtube_src: 'https://www.youtube.com/embed/PutvF_P4588',
		color_name: [
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 8,
	},
	{
		title: 'Tropical Seascape',
		img_src: 'https://www.twoinchbrush.com/images/painting145.png',
		img_src_index: 145,
		youtube_src: 'https://www.youtube.com/embed/RrBsbqO9aqI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 9,
	},
	{
		title: 'Mountain at Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting146.png',
		img_src_index: 146,
		youtube_src: 'https://www.youtube.com/embed/HCsCatvigtw',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 10,
	},
	{
		title: 'Soft Mountain Glow',
		img_src: 'https://www.twoinchbrush.com/images/painting147.png',
		img_src_index: 147,
		youtube_src: 'https://www.youtube.com/embed/gOGJYHWjXgE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 11,
	},
	{
		title: 'Mountain in an Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting148.png',
		img_src_index: 148,
		youtube_src: 'https://www.youtube.com/embed/1jRPshs27H8',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 12,
		episode: 12,
	},
	{
		title: 'Winter Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting149.png',
		img_src_index: 149,
		youtube_src: 'https://www.youtube.com/embed/46vI20697HI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#DB0000', '#000000', '#0C0040', '#021E44', '#FFFFFF', '#221B15'],
		season: 12,
		episode: 13,
	},
	{
		title: 'Rolling Hills',
		img_src: 'https://www.twoinchbrush.com/images/painting124.png',
		img_src_index: 124,
		youtube_src: 'https://www.youtube.com/embed/H4GyGrT7lEQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 1,
	},
	{
		title: 'Frozen Solitude',
		img_src: 'https://www.twoinchbrush.com/images/painting125.png',
		img_src_index: 125,
		youtube_src: 'https://www.youtube.com/embed/kNZssD9zWlw',
		color_name: [
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#5F2E1F', '#000000', '#021E44', '#FFFFFF', '#221B15'],
		season: 13,
		episode: 2,
	},
	{
		title: 'Meadow Brook',
		img_src: 'https://www.twoinchbrush.com/images/painting126.png',
		img_src_index: 126,
		youtube_src: 'https://www.youtube.com/embed/06W8GsWj2Yg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 3,
	},
	{
		title: 'Evening at Sunset',
		img_src: 'https://www.twoinchbrush.com/images/painting127.png',
		img_src_index: 127,
		youtube_src: 'https://www.youtube.com/embed/7ZUQTXuDPaI',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 4,
	},
	{
		title: 'Mountain View',
		img_src: 'https://www.twoinchbrush.com/images/painting128.png',
		img_src_index: 128,
		youtube_src: 'https://www.youtube.com/embed/dJfnAyDLwPY',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 5,
	},
	{
		title: 'Hidden Creek',
		img_src: 'https://www.twoinchbrush.com/images/painting129.png',
		img_src_index: 129,
		youtube_src: 'https://www.youtube.com/embed/KmoRz01bm0Y',
		color_name: [
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 6,
	},
	{
		title: 'Peaceful Haven',
		img_src: 'https://www.twoinchbrush.com/images/painting130.png',
		img_src_index: 130,
		youtube_src: 'https://www.youtube.com/embed/j20pZ96E_CE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 7,
	},
	{
		title: 'Mountain Exhibition',
		img_src: 'https://www.twoinchbrush.com/images/painting131.png',
		img_src_index: 131,
		youtube_src: 'https://www.youtube.com/embed/bgI3_1quJ18',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 8,
	},
	{
		title: 'Emerald Waters',
		img_src: 'https://www.twoinchbrush.com/images/painting132.png',
		img_src_index: 132,
		youtube_src: 'https://www.youtube.com/embed/lLunPQBzW6g',
		color_name: [
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 9,
	},
	{
		title: 'Mountain Summit',
		img_src: 'https://www.twoinchbrush.com/images/painting133.png',
		img_src_index: 133,
		youtube_src: 'https://www.youtube.com/embed/kasGRkfkiPM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 10,
	},
	{
		title: 'Cabin Hideaway',
		img_src: 'https://www.twoinchbrush.com/images/painting134.png',
		img_src_index: 134,
		youtube_src: 'https://www.youtube.com/embed/NjTlW2NL1Lo',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 11,
	},
	{
		title: 'Oval Essence',
		img_src: 'https://www.twoinchbrush.com/images/painting135.png',
		img_src_index: 135,
		youtube_src: 'https://www.youtube.com/embed/q7WXF_BSEXw',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#FFFFFF',
			'#221B15',
		],
		season: 13,
		episode: 12,
	},
	{
		title: 'Lost Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting136.png',
		img_src_index: 136,
		youtube_src: 'https://www.youtube.com/embed/9-ATP8xyDM0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 13,
		episode: 13,
	},
	{
		title: 'Distant Mountains',
		img_src: 'https://www.twoinchbrush.com/images/painting111.png',
		img_src_index: 111,
		youtube_src: 'https://www.youtube.com/embed/GpA9UM7QGag',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 1,
	},
	{
		title: 'Meadow Brook Surprise',
		img_src: 'https://www.twoinchbrush.com/images/painting112.png',
		img_src_index: 112,
		youtube_src: 'https://www.youtube.com/embed/Ov5oIHTAa10',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 2,
	},
	{
		title: 'Mountain Moonlight Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting113.png',
		img_src_index: 113,
		youtube_src: 'https://www.youtube.com/embed/CigXQtT6BPM',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 3,
	},
	{
		title: 'Snowy Solitude',
		img_src: 'https://www.twoinchbrush.com/images/painting114.png',
		img_src_index: 114,
		youtube_src: 'https://www.youtube.com/embed/1ZriQGhSFTM',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#FFFFFF', '#221B15', '#C79B00'],
		season: 14,
		episode: 4,
	},
	{
		title: 'Mountain River',
		img_src: 'https://www.twoinchbrush.com/images/painting115.png',
		img_src_index: 115,
		youtube_src: 'https://www.youtube.com/embed/CnMLKAGi0yM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 5,
	},
	{
		title: 'Graceful Mountains',
		img_src: 'https://www.twoinchbrush.com/images/painting116.png',
		img_src_index: 116,
		youtube_src: 'https://www.youtube.com/embed/0uVe8T-vVVg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 6,
	},
	{
		title: 'Windy Waves',
		img_src: 'https://www.twoinchbrush.com/images/painting117.png',
		img_src_index: 117,
		youtube_src: 'https://www.youtube.com/embed/y6GVVjG4HMg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 7,
	},
	{
		title: 'On a Clear Day',
		img_src: 'https://www.twoinchbrush.com/images/painting118.png',
		img_src_index: 118,
		youtube_src: 'https://www.youtube.com/embed/e63Cgln6Yag',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 8,
	},
	{
		title: 'Riverside Escape Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting119.png',
		img_src_index: 119,
		youtube_src: 'https://www.youtube.com/embed/d83REwSGfGo',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 9,
	},
	{
		title: 'Surprising Falls',
		img_src: 'https://www.twoinchbrush.com/images/painting120.png',
		img_src_index: 120,
		youtube_src: 'https://www.youtube.com/embed/QbclL1ca7_s',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 10,
	},
	{
		title: 'Shadow Pond',
		img_src: 'https://www.twoinchbrush.com/images/painting121.png',
		img_src_index: 121,
		youtube_src: 'https://www.youtube.com/embed/BQWJ3kqonpA',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 11,
	},
	{
		title: 'Misty Forest Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting122.png',
		img_src_index: 122,
		youtube_src: 'https://www.youtube.com/embed/ddU9vQvSpw8',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 12,
	},
	{
		title: 'Natural Wonder',
		img_src: 'https://www.twoinchbrush.com/images/painting123.png',
		img_src_index: 123,
		youtube_src: 'https://www.youtube.com/embed/knOutsaiKfU',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 14,
		episode: 13,
	},
	{
		title: 'Splendor of Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting98.png',
		img_src_index: 98,
		youtube_src: 'https://www.youtube.com/embed/oJvk7gPDHiE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 1,
	},
	{
		title: 'Colors of Nature',
		img_src: 'https://www.twoinchbrush.com/images/painting99.png',
		img_src_index: 99,
		youtube_src: 'https://www.youtube.com/embed/Me9Ietooq4w',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 2,
	},
	{
		title: "Grandpa's Barn",
		img_src: 'https://www.twoinchbrush.com/images/painting100.png',
		img_src_index: 100,
		youtube_src: 'https://www.youtube.com/embed/IPPU49PyfEA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 3,
	},
	{
		title: 'Peaceful Reflections',
		img_src: 'https://www.twoinchbrush.com/images/painting101.png',
		img_src_index: 101,
		youtube_src: 'https://www.youtube.com/embed/gYuH4Ilqdhs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 4,
	},
	{
		title: 'Hidden Winter Moon Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting102.png',
		img_src_index: 102,
		youtube_src: 'https://www.youtube.com/embed/yxAMOdl6RJE',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 15,
		episode: 5,
	},
	{
		title: 'Waves of Wonder',
		img_src: 'https://www.twoinchbrush.com/images/painting103.png',
		img_src_index: 103,
		youtube_src: 'https://www.youtube.com/embed/tayQX_ng-Nc',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 6,
	},
	{
		title: 'Cabin by the Pond',
		img_src: 'https://www.twoinchbrush.com/images/painting104.png',
		img_src_index: 104,
		youtube_src: 'https://www.youtube.com/embed/TyOO6WeP2AY',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 7,
	},
	{
		title: 'Fall Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting105.png',
		img_src_index: 105,
		youtube_src: 'https://www.youtube.com/embed/ZY0ofhdV_L0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 8,
	},
	{
		title: 'Christmas Eve Snow',
		img_src: 'https://www.twoinchbrush.com/images/painting106.png',
		img_src_index: 106,
		youtube_src: 'https://www.youtube.com/embed/cVqFG2pxK2A',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 15,
		episode: 9,
	},
	{
		title: 'Forest Down Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting107.png',
		img_src_index: 107,
		youtube_src: 'https://www.youtube.com/embed/COsJUfPN2dA',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 10,
	},
	{
		title: 'Pathway to Autumn',
		img_src: 'https://www.twoinchbrush.com/images/painting108.png',
		img_src_index: 108,
		youtube_src: 'https://www.youtube.com/embed/Hg5RKc6xiL4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 11,
	},
	{
		title: 'Deep Forest Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting109.png',
		img_src_index: 109,
		youtube_src: 'https://www.youtube.com/embed/2bjFmSQjQrw',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 12,
	},
	{
		title: 'Peaks of Majesty',
		img_src: 'https://www.twoinchbrush.com/images/painting110.png',
		img_src_index: 110,
		youtube_src: 'https://www.youtube.com/embed/lTb8DN6G6dE',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 15,
		episode: 13,
	},
	{
		title: 'Two Seasons',
		img_src: 'https://www.twoinchbrush.com/images/painting84.png',
		img_src_index: 84,
		youtube_src: 'https://www.youtube.com/embed/jwVz0uTLH1I',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 1,
	},
	{
		title: 'Nestled Cabin',
		img_src: 'https://www.twoinchbrush.com/images/painting85.png',
		img_src_index: 85,
		youtube_src: 'https://www.youtube.com/embed/l_jN9KN257M',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 2,
	},
	{
		title: 'Wintertime Discovery',
		img_src: 'https://www.twoinchbrush.com/images/painting86.png',
		img_src_index: 86,
		youtube_src: 'https://www.youtube.com/embed/uZyZW3tkCE0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 3,
	},
	{
		title: 'Mountain Mirage Wood Shape',
		img_src: 'https://www.twoinchbrush.com/images/painting87.png',
		img_src_index: 87,
		youtube_src: 'https://www.youtube.com/embed/jfCsew_mz7A',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 4,
	},
	{
		title: 'Double Oval Fantasy',
		img_src: 'https://www.twoinchbrush.com/images/painting88.png',
		img_src_index: 88,
		youtube_src: 'https://www.youtube.com/embed/4jAsLpJzjHM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 5,
	},
	{
		title: 'Contemplative Lady',
		img_src: 'https://www.twoinchbrush.com/images/painting89.png',
		img_src_index: 89,
		youtube_src: 'https://www.youtube.com/embed/gnp6WE7Ql-s',
		color_name: ['Van Dyke Brown'],
		color_hex: ['#221B15'],
		season: 16,
		episode: 6,
	},
	{
		title: 'Deep Woods',
		img_src: 'https://www.twoinchbrush.com/images/painting90.png',
		img_src_index: 90,
		youtube_src: 'https://www.youtube.com/embed/rE5ZVs_YJfE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 7,
	},
	{
		title: 'High Tide',
		img_src: 'https://www.twoinchbrush.com/images/painting91.png',
		img_src_index: 91,
		youtube_src: 'https://www.youtube.com/embed/_IREQ4SIcX8',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 8,
	},
	{
		title: 'Barn in Snow Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting93.png',
		img_src_index: 93,
		youtube_src: 'https://www.youtube.com/embed/wJmi7-G9r-w',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#FFFFFF', '#221B15', '#C79B00'],
		season: 16,
		episode: 9,
	},
	{
		title: 'That Time of Year',
		img_src: 'https://www.twoinchbrush.com/images/painting94.png',
		img_src_index: 94,
		youtube_src: 'https://www.youtube.com/embed/q5moLoqOkP0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 16,
		episode: 10,
	},
	{
		title: 'Waterfall Wonder',
		img_src: 'https://www.twoinchbrush.com/images/painting95.png',
		img_src_index: 95,
		youtube_src: 'https://www.youtube.com/embed/AGhXEPfp-W4',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 11,
	},
	{
		title: 'Mighty Mountain Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting96.png',
		img_src_index: 96,
		youtube_src: 'https://www.youtube.com/embed/4vXB2R8ybDE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 12,
	},
	{
		title: 'Wooded Stream Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting97.png',
		img_src_index: 97,
		youtube_src: 'https://www.youtube.com/embed/-XA2h17y3HU',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 16,
		episode: 13,
	},
	{
		title: 'Golden Mist Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting71.png',
		img_src_index: 71,
		youtube_src: 'https://www.youtube.com/embed/lhpfaW0k6uM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 1,
	},
	{
		title: 'The Old Home Place',
		img_src: 'https://www.twoinchbrush.com/images/painting72.png',
		img_src_index: 72,
		youtube_src: 'https://www.youtube.com/embed/EVQcDEiJh2o',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 2,
	},
	{
		title: 'Soothing Vista',
		img_src: 'https://www.twoinchbrush.com/images/painting73.png',
		img_src_index: 73,
		youtube_src: 'https://www.youtube.com/embed/NqfRLiv0SZ0',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 3,
	},
	{
		title: 'Stormy Seas',
		img_src: 'https://www.twoinchbrush.com/images/painting74.png',
		img_src_index: 74,
		youtube_src: 'https://www.youtube.com/embed/LE6agCR5iBw',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 4,
	},
	{
		title: 'Country Time',
		img_src: 'https://www.twoinchbrush.com/images/painting75.png',
		img_src_index: 75,
		youtube_src: 'https://www.youtube.com/embed/e_bt9rQoGN0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 5,
	},
	{
		title: "A Mild Winter's Day",
		img_src: 'https://www.twoinchbrush.com/images/painting76.png',
		img_src_index: 76,
		youtube_src: 'https://www.youtube.com/embed/BbYO579MmhA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 6,
	},
	{
		title: 'Spectacular Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting77.png',
		img_src_index: 77,
		youtube_src: 'https://www.youtube.com/embed/nK-HebXL2uw',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 7,
	},
	{
		title: 'View from the Park',
		img_src: 'https://www.twoinchbrush.com/images/painting78.png',
		img_src_index: 78,
		youtube_src: 'https://www.youtube.com/embed/Q4n90jsOUtY',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 8,
	},
	{
		title: 'Lake View',
		img_src: 'https://www.twoinchbrush.com/images/painting79.png',
		img_src_index: 79,
		youtube_src: 'https://www.youtube.com/embed/07acfzBaoa0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 9,
	},
	{
		title: 'Old Country Mill',
		img_src: 'https://www.twoinchbrush.com/images/painting80.png',
		img_src_index: 80,
		youtube_src: 'https://www.youtube.com/embed/n8HlFCQACYA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 10,
	},
	{
		title: 'Morning Walk',
		img_src: 'https://www.twoinchbrush.com/images/painting81.png',
		img_src_index: 81,
		youtube_src: 'https://www.youtube.com/embed/pSvgNkQdR2Y',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 11,
	},
	{
		title: "Nature's Splendor",
		img_src: 'https://www.twoinchbrush.com/images/painting82.png',
		img_src_index: 82,
		youtube_src: 'https://www.youtube.com/embed/uCAtI2IwEwk',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 12,
	},
	{
		title: 'Mountain Beauty',
		img_src: 'https://www.twoinchbrush.com/images/painting83.png',
		img_src_index: 83,
		youtube_src: 'https://www.youtube.com/embed/8P-YeoTmVrw',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 17,
		episode: 13,
	},
	{
		title: 'Half-Oval Vignette',
		img_src: 'https://www.twoinchbrush.com/images/painting58.png',
		img_src_index: 58,
		youtube_src: 'https://www.youtube.com/embed/uY3fIry2tOE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 1,
	},
	{
		title: 'Absolutely Autumn',
		img_src: 'https://www.twoinchbrush.com/images/painting59.png',
		img_src_index: 59,
		youtube_src: 'https://www.youtube.com/embed/PGPVpil2UmE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 2,
	},
	{
		title: 'Mountain Seclusion',
		img_src: 'https://www.twoinchbrush.com/images/painting60.png',
		img_src_index: 60,
		youtube_src: 'https://www.youtube.com/embed/EBZKuVbRY54',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 18,
		episode: 3,
	},
	{
		title: 'Crimson Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting61.png',
		img_src_index: 61,
		youtube_src: 'https://www.youtube.com/embed/R7Y3izMFPbM',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 4,
	},
	{
		title: 'Autumn Exhibition',
		img_src: 'https://www.twoinchbrush.com/images/painting62.png',
		img_src_index: 62,
		youtube_src: 'https://www.youtube.com/embed/6afHY2d9Lv8',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 5,
	},
	{
		title: 'Majestic Peaks',
		img_src: 'https://www.twoinchbrush.com/images/painting63.png',
		img_src_index: 63,
		youtube_src: 'https://www.youtube.com/embed/lilbzLCNnDo',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 6,
	},
	{
		title: 'Golden Morning Mist',
		img_src: 'https://www.twoinchbrush.com/images/painting64.png',
		img_src_index: 64,
		youtube_src: 'https://www.youtube.com/embed/rCHXqj4DHlM',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 7,
	},
	{
		title: 'Winter Lace',
		img_src: 'https://www.twoinchbrush.com/images/painting65.png',
		img_src_index: 65,
		youtube_src: 'https://www.youtube.com/embed/WJF_qoQRPck',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 18,
		episode: 8,
	},
	{
		title: 'Seascape Fantasy',
		img_src: 'https://www.twoinchbrush.com/images/painting66.png',
		img_src_index: 66,
		youtube_src: 'https://www.youtube.com/embed/sBBBilrDuSw',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 9,
	},
	{
		title: 'Double Oval Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting67.png',
		img_src_index: 67,
		youtube_src: 'https://www.youtube.com/embed/rRjnHdr9DmU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 10,
	},
	{
		title: 'Enchanted Forest',
		img_src: 'https://www.twoinchbrush.com/images/painting68.png',
		img_src_index: 68,
		youtube_src: 'https://www.youtube.com/embed/ikR7UT9mVBw',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 11,
	},
	{
		title: 'Southwest Serenity',
		img_src: 'https://www.twoinchbrush.com/images/painting69.png',
		img_src_index: 69,
		youtube_src: 'https://www.youtube.com/embed/EVfPPJ5FUmA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 12,
	},
	{
		title: 'Rippling Waters',
		img_src: 'https://www.twoinchbrush.com/images/painting70.png',
		img_src_index: 70,
		youtube_src: 'https://www.youtube.com/embed/XvnJBynSiT0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 18,
		episode: 13,
	},
	{
		title: 'Snowfall Magic',
		img_src: 'https://www.twoinchbrush.com/images/painting44.png',
		img_src_index: 44,
		youtube_src: 'https://www.youtube.com/embed/1enWTsRi16o',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 1,
	},
	{
		title: 'Quiet Mountain Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting45.png',
		img_src_index: 45,
		youtube_src: 'https://www.youtube.com/embed/2gq2V6dCt2I',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 2,
	},
	{
		title: 'Final Embers of Sunlight',
		img_src: 'https://www.twoinchbrush.com/images/painting46.png',
		img_src_index: 46,
		youtube_src: 'https://www.youtube.com/embed/IeFbdk36MUU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 3,
	},
	{
		title: 'Snowy Morn',
		img_src: 'https://www.twoinchbrush.com/images/painting47.png',
		img_src_index: 47,
		youtube_src: 'https://www.youtube.com/embed/iB1TDWlo0kk',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#021E44', '#FFFFFF', '#221B15', '#C79B00'],
		season: 19,
		episode: 4,
	},
	{
		title: "Camper's Haven",
		img_src: 'https://www.twoinchbrush.com/images/painting48.png',
		img_src_index: 48,
		youtube_src: 'https://www.youtube.com/embed/C34WAUgkAT0',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 5,
	},
	{
		title: 'Waterfall in the Woods',
		img_src: 'https://www.twoinchbrush.com/images/painting49.png',
		img_src_index: 49,
		youtube_src: 'https://www.youtube.com/embed/uBRKVa7sy1Q',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 6,
	},
	{
		title: 'Covered Bridge Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting50.png',
		img_src_index: 50,
		youtube_src: 'https://www.youtube.com/embed/F4iPbH1OHsQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 7,
	},
	{
		title: 'Scenic Seclusion',
		img_src: 'https://www.twoinchbrush.com/images/painting51.png',
		img_src_index: 51,
		youtube_src: 'https://www.youtube.com/embed/d50HkqB9JEM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 8,
	},
	{
		title: 'Ebb Tide',
		img_src: 'https://www.twoinchbrush.com/images/painting52.png',
		img_src_index: 52,
		youtube_src: 'https://www.youtube.com/embed/mFOna_LN7Ys',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 9,
	},
	{
		title: 'After the Rain',
		img_src: 'https://www.twoinchbrush.com/images/painting53.png',
		img_src_index: 53,
		youtube_src: 'https://www.youtube.com/embed/Wj-3ct7RvAI',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 10,
	},
	{
		title: 'Winter Elegance',
		img_src: 'https://www.twoinchbrush.com/images/painting54.png',
		img_src_index: 54,
		youtube_src: 'https://www.youtube.com/embed/JjBZzKp_u5E',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 11,
	},
	{
		title: "Evening's Peace",
		img_src: 'https://www.twoinchbrush.com/images/painting56.png',
		img_src_index: 56,
		youtube_src: 'https://www.youtube.com/embed/uEUMVwc4o5U',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 19,
		episode: 12,
	},
	{
		title: 'Valley of Tranquility',
		img_src: 'https://www.twoinchbrush.com/images/painting57.png',
		img_src_index: 57,
		youtube_src: 'https://www.youtube.com/embed/FnY7jDY5PsE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 19,
		episode: 13,
	},
	{
		title: 'Mystic Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting31.png',
		img_src_index: 31,
		youtube_src: 'https://www.youtube.com/embed/VlucWfTUo1A',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 1,
	},
	{
		title: "New Day's Dawn",
		img_src: 'https://www.twoinchbrush.com/images/painting32.png',
		img_src_index: 32,
		youtube_src: 'https://www.youtube.com/embed/vbPdQ0w8ylg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 2,
	},
	{
		title: 'Winter in Pastel',
		img_src: 'https://www.twoinchbrush.com/images/painting33.png',
		img_src_index: 33,
		youtube_src: 'https://www.youtube.com/embed/kbnXZRNMouM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 3,
	},
	{
		title: 'Hazy Day',
		img_src: 'https://www.twoinchbrush.com/images/painting34.png',
		img_src_index: 34,
		youtube_src: 'https://www.youtube.com/embed/5U3G61r35Mc',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 4,
	},
	{
		title: 'Divine Elegance',
		img_src: 'https://www.twoinchbrush.com/images/painting35.png',
		img_src_index: 35,
		youtube_src: 'https://www.youtube.com/embed/mb-Gwx1S5Gs',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 5,
	},
	{
		title: 'Cliffside',
		img_src: 'https://www.twoinchbrush.com/images/painting36.png',
		img_src_index: 36,
		youtube_src: 'https://www.youtube.com/embed/p6Uy2qOLvGk',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 6,
	},
	{
		title: 'Autumn Fantasy',
		img_src: 'https://www.twoinchbrush.com/images/painting37.png',
		img_src_index: 37,
		youtube_src: 'https://www.youtube.com/embed/FozIp7Va7dY',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 7,
	},
	{
		title: 'The Old Oak Tree',
		img_src: 'https://www.twoinchbrush.com/images/painting38.png',
		img_src_index: 38,
		youtube_src: 'https://www.youtube.com/embed/dN4HjAn8p5U',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 8,
	},
	{
		title: 'Winter Paradise',
		img_src: 'https://www.twoinchbrush.com/images/painting39.png',
		img_src_index: 39,
		youtube_src: 'https://www.youtube.com/embed/DY1aBv8Z1SQ',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#021E44', '#FFFFFF'],
		season: 20,
		episode: 9,
	},
	{
		title: 'Days Gone By',
		img_src: 'https://www.twoinchbrush.com/images/painting40.png',
		img_src_index: 40,
		youtube_src: 'https://www.youtube.com/embed/DmYhNHVIdMI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 10,
	},
	{
		title: 'Change of Seasons',
		img_src: 'https://www.twoinchbrush.com/images/painting41.png',
		img_src_index: 41,
		youtube_src: 'https://www.youtube.com/embed/QbgPu5f2Vf8',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 11,
	},
	{
		title: 'Hidden Delight',
		img_src: 'https://www.twoinchbrush.com/images/painting42.png',
		img_src_index: 42,
		youtube_src: 'https://www.youtube.com/embed/ZyPNzDaaDt8',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 12,
	},
	{
		title: 'Double Take',
		img_src: 'https://www.twoinchbrush.com/images/painting43.png',
		img_src_index: 43,
		youtube_src: 'https://www.youtube.com/embed/ppzFgG2K2k4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 20,
		episode: 13,
	},
	{
		title: 'Valley View',
		img_src: 'https://www.twoinchbrush.com/images/painting17.png',
		img_src_index: 17,
		youtube_src: 'https://www.youtube.com/embed/pw5ETGiiBRg',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 1,
	},
	{
		title: 'Tranquil Dawn',
		img_src: 'https://www.twoinchbrush.com/images/painting18.png',
		img_src_index: 18,
		youtube_src: 'https://www.youtube.com/embed/4abDq6Q-mlM',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 2,
	},
	{
		title: 'Royal Majesty',
		img_src: 'https://www.twoinchbrush.com/images/painting19.png',
		img_src_index: 19,
		youtube_src: 'https://www.youtube.com/embed/ubUXBqE6t0U',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 3,
	},
	{
		title: 'Serenity',
		img_src: 'https://www.twoinchbrush.com/images/painting20.png',
		img_src_index: 20,
		youtube_src: 'https://www.youtube.com/embed/crqmO3qDdco',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 4,
	},
	{
		title: 'Cabin at Trails End',
		img_src: 'https://www.twoinchbrush.com/images/painting21.png',
		img_src_index: 21,
		youtube_src: 'https://www.youtube.com/embed/GLkLO4KqTRs',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 5,
	},
	{
		title: 'Mountain Rhapsody',
		img_src: 'https://www.twoinchbrush.com/images/painting22.png',
		img_src_index: 22,
		youtube_src: 'https://www.youtube.com/embed/H4VsmKU5T7g',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 6,
	},
	{
		title: 'Wilderness Cabin',
		img_src: 'https://www.twoinchbrush.com/images/painting23.png',
		img_src_index: 23,
		youtube_src: 'https://www.youtube.com/embed/GWehiacnd1E',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 7,
	},
	{
		title: 'By the Sea',
		img_src: 'https://www.twoinchbrush.com/images/painting24.png',
		img_src_index: 24,
		youtube_src: 'https://www.youtube.com/embed/8tHHBTK6wwc',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 8,
	},
	{
		title: 'Indian Summer',
		img_src: 'https://www.twoinchbrush.com/images/painting25.png',
		img_src_index: 25,
		youtube_src: 'https://www.youtube.com/embed/pfWV8NkotvU',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 9,
	},
	{
		title: 'Blue Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting27.png',
		img_src_index: 27,
		youtube_src: 'https://www.youtube.com/embed/liR0gS0sZY0',
		color_name: ['Midnight Black', 'Prussian Blue', 'Titanium White'],
		color_hex: ['#000000', '#021E44', '#FFFFFF'],
		season: 21,
		episode: 10,
	},
	{
		title: 'Desert Glow',
		img_src: 'https://www.twoinchbrush.com/images/painting28.png',
		img_src_index: 28,
		youtube_src: 'https://www.youtube.com/embed/QyncJfL_HmU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 21,
		episode: 11,
	},
	{
		title: 'Lone Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting29.png',
		img_src_index: 29,
		youtube_src: 'https://www.youtube.com/embed/NJbzIftLLmU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 12,
	},
	{
		title: "Florida's Glory",
		img_src: 'https://www.twoinchbrush.com/images/painting30.png',
		img_src_index: 30,
		youtube_src: 'https://www.youtube.com/embed/HQC5sPN9Xhc',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 21,
		episode: 13,
	},
	{
		title: 'Autumn Images',
		img_src: 'https://www.twoinchbrush.com/images/painting14.png',
		img_src_index: 14,
		youtube_src: 'https://www.youtube.com/embed/HMx34Am6RFg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Red',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#CD5C5C',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 1,
	},
	{
		title: 'Hint of Springtime',
		img_src: 'https://www.twoinchbrush.com/images/painting15.png',
		img_src_index: 15,
		youtube_src: 'https://www.youtube.com/embed/C-OSaHvt8ms',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 2,
	},
	{
		title: 'Around the Bend',
		img_src: 'https://www.twoinchbrush.com/images/painting16.png',
		img_src_index: 16,
		youtube_src: 'https://www.youtube.com/embed/Kl5X3icOVvw',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 3,
	},
	{
		title: 'Countryside Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting4.png',
		img_src_index: 4,
		youtube_src: 'https://www.youtube.com/embed/hdNH5axK4u0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 4,
	},
	{
		title: 'Russet Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting5.png',
		img_src_index: 5,
		youtube_src: 'https://www.youtube.com/embed/aE4nID1p-t0',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 5,
	},
	{
		title: 'Purple Haze',
		img_src: 'https://www.twoinchbrush.com/images/painting6.png',
		img_src_index: 6,
		youtube_src: 'https://www.youtube.com/embed/ZoJ2tcXWb7g',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 6,
	},
	{
		title: 'Dimensions',
		img_src: 'https://www.twoinchbrush.com/images/painting7.png',
		img_src_index: 7,
		youtube_src: 'https://www.youtube.com/embed/JUuP75RVZDI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 7,
	},
	{
		title: 'Deep Wilderness Home',
		img_src: 'https://www.twoinchbrush.com/images/painting8.png',
		img_src_index: 8,
		youtube_src: 'https://www.youtube.com/embed/uZWNvDFfbUk',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 8,
	},
	{
		title: 'Haven in the Valley',
		img_src: 'https://www.twoinchbrush.com/images/painting9.png',
		img_src_index: 9,
		youtube_src: 'https://www.youtube.com/embed/Qccgam514ds',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 9,
	},
	{
		title: 'Wintertime Blues',
		img_src: 'https://www.twoinchbrush.com/images/painting10.png',
		img_src_index: 10,
		youtube_src: 'https://www.youtube.com/embed/dbMJVM4iL2Q',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#021E44', '#FFFFFF', '#221B15'],
		season: 22,
		episode: 10,
	},
	{
		title: 'Pastel Seascape',
		img_src: 'https://www.twoinchbrush.com/images/painting11.png',
		img_src_index: 11,
		youtube_src: 'https://www.youtube.com/embed/K4aud_SpFDQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 11,
	},
	{
		title: 'Country Creek',
		img_src: 'https://www.twoinchbrush.com/images/painting12.png',
		img_src_index: 12,
		youtube_src: 'https://www.youtube.com/embed/JDa6JPcqy88',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 12,
	},
	{
		title: 'Silent Forest',
		img_src: 'https://www.twoinchbrush.com/images/painting13.png',
		img_src_index: 13,
		youtube_src: 'https://www.youtube.com/embed/AE1GKcL3NuI',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 22,
		episode: 13,
	},
	{
		title: 'Frosty Winter Morn',
		img_src: 'https://www.twoinchbrush.com/images/painting295.png',
		img_src_index: 295,
		youtube_src: 'https://www.youtube.com/embed/1-9_enMBquw',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 23,
		episode: 1,
	},
	{
		title: 'Forest Edge',
		img_src: 'https://www.twoinchbrush.com/images/painting296.png',
		img_src_index: 296,
		youtube_src: 'https://www.youtube.com/embed/puGk2iFvvp0',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 2,
	},
	{
		title: 'Mountain Ridge Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting297.png',
		img_src_index: 297,
		youtube_src: 'https://www.youtube.com/embed/Hq-z06i6HCs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 3,
	},
	{
		title: 'Reflections of Gold',
		img_src: 'https://www.twoinchbrush.com/images/painting298.png',
		img_src_index: 298,
		youtube_src: 'https://www.youtube.com/embed/8f9CCnqJ_1Y',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 4,
	},
	{
		title: 'Quiet Cove',
		img_src: 'https://www.twoinchbrush.com/images/painting299.png',
		img_src_index: 299,
		youtube_src: 'https://www.youtube.com/embed/cR9hTbSomx4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 5,
	},
	{
		title: 'Rivers Peace',
		img_src: 'https://www.twoinchbrush.com/images/painting300.png',
		img_src_index: 300,
		youtube_src: 'https://www.youtube.com/embed/flCWS9LB4Ks',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 6,
	},
	{
		title: "At Dawn's Light",
		img_src: 'https://www.twoinchbrush.com/images/painting301.png',
		img_src_index: 301,
		youtube_src: 'https://www.youtube.com/embed/HFdTxqEznIk',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 7,
	},
	{
		title: 'Valley Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting302.png',
		img_src_index: 302,
		youtube_src: 'https://www.youtube.com/embed/VYcsYzzRae4',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 8,
	},
	{
		title: 'Toward Days End',
		img_src: 'https://www.twoinchbrush.com/images/painting303.png',
		img_src_index: 303,
		youtube_src: 'https://www.youtube.com/embed/cFi_fJl40BA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 9,
	},
	{
		title: 'Falls in the Glen',
		img_src: 'https://www.twoinchbrush.com/images/painting304.png',
		img_src_index: 304,
		youtube_src: 'https://www.youtube.com/embed/txAtX-VyVNc',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 10,
	},
	{
		title: 'Frozen Beauty in Vignette',
		img_src: 'https://www.twoinchbrush.com/images/painting305.png',
		img_src_index: 305,
		youtube_src: 'https://www.youtube.com/embed/H15kV1wbDG4',
		color_name: [
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#DB0000',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 11,
	},
	{
		title: 'Crimson Tide',
		img_src: 'https://www.twoinchbrush.com/images/painting306.png',
		img_src_index: 306,
		youtube_src: 'https://www.youtube.com/embed/Y7SDU4i6Fco',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 23,
		episode: 12,
	},
	{
		title: 'Winter Bliss',
		img_src: 'https://www.twoinchbrush.com/images/painting307.png',
		img_src_index: 307,
		youtube_src: 'https://www.youtube.com/embed/yInYwy6AsDQ',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#021E44', '#FFFFFF', '#221B15'],
		season: 23,
		episode: 13,
	},
	{
		title: 'Gray Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting308.png',
		img_src_index: 308,
		youtube_src: 'https://www.youtube.com/embed/4XxClvPZ1RE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 24,
		episode: 1,
	},
	{
		title: 'Wayside Pond',
		img_src: 'https://www.twoinchbrush.com/images/painting309.png',
		img_src_index: 309,
		youtube_src: 'https://www.youtube.com/embed/FPW2FwK4IOo',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 24,
		episode: 2,
	},
	{
		title: 'Teton Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting310.png',
		img_src_index: 310,
		youtube_src: 'https://www.youtube.com/embed/I4h6TC4CPJY',
		color_name: [
			'Alizarin Crimson',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
		],
		color_hex: ['#4E1500', '#000000', '#0C0040', '#021E44', '#0A3410', '#FFFFFF'],
		season: 24,
		episode: 3,
	},
	{
		title: 'Little Home in the Meadow',
		img_src: 'https://www.twoinchbrush.com/images/painting311.png',
		img_src_index: 311,
		youtube_src: 'https://www.youtube.com/embed/nU1zV93N-kI',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 24,
		episode: 4,
	},
	{
		title: 'A Pretty Autumn Day',
		img_src: 'https://www.twoinchbrush.com/images/painting312.png',
		img_src_index: 312,
		youtube_src: 'https://www.youtube.com/embed/HWedDS3p7XI',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 24,
		episode: 5,
	},
	{
		title: 'Mirrored Images',
		img_src: 'https://www.twoinchbrush.com/images/painting313.png',
		img_src_index: 313,
		youtube_src: 'https://www.youtube.com/embed/i29frkR1T98',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 24,
		episode: 6,
	},
	{
		title: 'Back-Country Path',
		img_src: 'https://www.twoinchbrush.com/images/painting314.png',
		img_src_index: 314,
		youtube_src: 'https://www.youtube.com/embed/2iNMoQB1Pe8',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 24,
		episode: 7,
	},
	{
		title: 'Graceful Waterfall',
		img_src: 'https://www.twoinchbrush.com/images/painting315.png',
		img_src_index: 315,
		youtube_src: 'https://www.youtube.com/embed/fBh1nA4pMDY',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 24,
		episode: 8,
	},
	{
		title: 'Icy Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting316.png',
		img_src_index: 316,
		youtube_src: 'https://www.youtube.com/embed/AmBDmgta3l4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 24,
		episode: 9,
	},
	{
		title: 'Rowboat on the Beach',
		img_src: 'https://www.twoinchbrush.com/images/painting317.png',
		img_src_index: 317,
		youtube_src: 'https://www.youtube.com/embed/hfvhXOvg43w',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 24,
		episode: 10,
	},
	{
		title: 'Portrait of Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting318.png',
		img_src_index: 318,
		youtube_src: 'https://www.youtube.com/embed/JLnIUGOupOA',
		color_name: [
			'Alizarin Crimson',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
		],
		color_hex: ['#4E1500', '#000000', '#0C0040', '#021E44', '#FFFFFF'],
		season: 24,
		episode: 11,
	},
	{
		title: 'The Footbridge',
		img_src: 'https://www.twoinchbrush.com/images/painting319.png',
		img_src_index: 319,
		youtube_src: 'https://www.youtube.com/embed/RqtDliGeyTg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 24,
		episode: 12,
	},
	{
		title: 'Snowbound Cabin',
		img_src: 'https://www.twoinchbrush.com/images/painting320.png',
		img_src_index: 320,
		youtube_src: 'https://www.youtube.com/embed/obSLZWXmDak',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
		],
		season: 24,
		episode: 13,
	},
	{
		title: 'Hide A Way Cove',
		img_src: 'https://www.twoinchbrush.com/images/painting321.png',
		img_src_index: 321,
		youtube_src: 'https://www.youtube.com/embed/l_HqMYquc08',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 1,
	},
	{
		title: 'Enchanted Falls Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting322.png',
		img_src_index: 322,
		youtube_src: 'https://www.youtube.com/embed/HklPkQ0lSKA',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Indian Yellow',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: ['#4E1500', '#000000', '#FFB800', '#0A3410', '#FFFFFF', '#C79B00'],
		season: 25,
		episode: 2,
	},
	{
		title: 'Not Quite Spring',
		img_src: 'https://www.twoinchbrush.com/images/painting323.png',
		img_src_index: 323,
		youtube_src: 'https://www.youtube.com/embed/N_u6x7LeyTM',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 3,
	},
	{
		title: 'Splashes of Autumn',
		img_src: 'https://www.twoinchbrush.com/images/painting324.png',
		img_src_index: 324,
		youtube_src: 'https://www.youtube.com/embed/YcbaMqq_X8s',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 4,
	},
	{
		title: 'Summer in the Mountain',
		img_src: 'https://www.twoinchbrush.com/images/painting325.png',
		img_src_index: 325,
		youtube_src: 'https://www.youtube.com/embed/gmCXgS38NDc',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 5,
	},
	{
		title: 'Oriental Falls',
		img_src: 'https://www.twoinchbrush.com/images/painting326.png',
		img_src_index: 326,
		youtube_src: 'https://www.youtube.com/embed/v8Znj8bbmCQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 6,
	},
	{
		title: 'Autumn Palette',
		img_src: 'https://www.twoinchbrush.com/images/painting327.png',
		img_src_index: 327,
		youtube_src: 'https://www.youtube.com/embed/HWrvW-NgaOY',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 7,
	},
	{
		title: 'Cypress Swamp',
		img_src: 'https://www.twoinchbrush.com/images/painting328.png',
		img_src_index: 328,
		youtube_src: 'https://www.youtube.com/embed/FdIUHudQABI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 8,
	},
	{
		title: 'Downstream View',
		img_src: 'https://www.twoinchbrush.com/images/painting329.png',
		img_src_index: 329,
		youtube_src: 'https://www.youtube.com/embed/KsDPg5HZYNw',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 9,
	},
	{
		title: 'Just Before the Storm',
		img_src: 'https://www.twoinchbrush.com/images/painting330.png',
		img_src_index: 330,
		youtube_src: 'https://www.youtube.com/embed/Rh-jKrMrmOA',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 25,
		episode: 10,
	},
	{
		title: "Fisherman's Paradise",
		img_src: 'https://www.twoinchbrush.com/images/painting331.png',
		img_src_index: 331,
		youtube_src: 'https://www.youtube.com/embed/uJLK85uU5mA',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 11,
	},
	{
		title: 'Desert Hues',
		img_src: 'https://www.twoinchbrush.com/images/painting332.png',
		img_src_index: 332,
		youtube_src: 'https://www.youtube.com/embed/UUNNXGVNTuI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 12,
	},
	{
		title: 'The Property Line',
		img_src: 'https://www.twoinchbrush.com/images/painting333.png',
		img_src_index: 333,
		youtube_src: 'https://www.youtube.com/embed/ivesI3rU7dU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 25,
		episode: 13,
	},
	{
		title: 'In the Stillness of Morning',
		img_src: 'https://www.twoinchbrush.com/images/painting334.png',
		img_src_index: 334,
		youtube_src: 'https://www.youtube.com/embed/5rfGa1_iJpw',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 26,
		episode: 1,
	},
	{
		title: 'Delightful Meadow Home',
		img_src: 'https://www.twoinchbrush.com/images/painting335.png',
		img_src_index: 335,
		youtube_src: 'https://www.youtube.com/embed/tWoInh2USOs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 26,
		episode: 2,
	},
	{
		title: 'First Snow',
		img_src: 'https://www.twoinchbrush.com/images/painting336.png',
		img_src_index: 336,
		youtube_src: 'https://www.youtube.com/embed/raAkJKeo0Sk',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 26,
		episode: 3,
	},
	{
		title: 'Lake in the Valley',
		img_src: 'https://www.twoinchbrush.com/images/painting337.png',
		img_src_index: 337,
		youtube_src: 'https://www.youtube.com/embed/KvJmSrErm20',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 26,
		episode: 4,
	},
	{
		title: 'A Trace of Spring',
		img_src: 'https://www.twoinchbrush.com/images/painting338.png',
		img_src_index: 338,
		youtube_src: 'https://www.youtube.com/embed/JMPwj3u4ZTA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 26,
		episode: 5,
	},
	{
		title: 'An Arctic Winter Day',
		img_src: 'https://www.twoinchbrush.com/images/painting339.png',
		img_src_index: 339,
		youtube_src: 'https://www.youtube.com/embed/9BHWlbjd95c',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#021E44', '#FFFFFF', '#221B15'],
		season: 26,
		episode: 6,
	},
	{
		title: 'Snow Birch',
		img_src: 'https://www.twoinchbrush.com/images/painting340.png',
		img_src_index: 340,
		youtube_src: 'https://www.youtube.com/embed/wKeemvioVrM',
		color_name: ['Black Gesso', 'Indian Yellow', 'Phthalo Blue', 'Prussian Blue', 'Titanium White'],
		color_hex: ['#000000', '#FFB800', '#0C0040', '#021E44', '#FFFFFF'],
		season: 26,
		episode: 7,
	},
	{
		title: 'Early Autumn',
		img_src: 'https://www.twoinchbrush.com/images/painting341.png',
		img_src_index: 341,
		youtube_src: 'https://www.youtube.com/embed/SLQXlFLoqQc',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 26,
		episode: 8,
	},
	{
		title: 'Tranquil Wooded Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting342.png',
		img_src_index: 342,
		youtube_src: 'https://www.youtube.com/embed/lSeRrm5ZK9c',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 26,
		episode: 9,
	},
	{
		title: 'Purple Mountain Range',
		img_src: 'https://www.twoinchbrush.com/images/painting343.png',
		img_src_index: 343,
		youtube_src: 'https://www.youtube.com/embed/nkDA_R-XmqA',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 26,
		episode: 10,
	},
	{
		title: "Storm's A Comin",
		img_src: 'https://www.twoinchbrush.com/images/painting344.png',
		img_src_index: 344,
		youtube_src: 'https://www.youtube.com/embed/EHD9u-lo2wc',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#FFFFFF',
			'#221B15',
		],
		season: 26,
		episode: 11,
	},
	{
		title: 'Sunset Aglow',
		img_src: 'https://www.twoinchbrush.com/images/painting345.png',
		img_src_index: 345,
		youtube_src: 'https://www.youtube.com/embed/gMEZp47VKC0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 26,
		episode: 12,
	},
	{
		title: 'Evening at the Falls',
		img_src: 'https://www.twoinchbrush.com/images/painting346.png',
		img_src_index: 346,
		youtube_src: 'https://www.youtube.com/embed/RulXVcpgpqw',
		color_name: [
			'Black Gesso',
			'Cadmium Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
		],
		color_hex: ['#000000', '#FFEC00', '#FFFFFF', '#000000', '#021E44', '#0A3410', '#FFFFFF'],
		season: 26,
		episode: 13,
	},
	{
		title: 'Twilight Beauty',
		img_src: 'https://www.twoinchbrush.com/images/painting347.png',
		img_src_index: 347,
		youtube_src: 'https://www.youtube.com/embed/0mJqzzeWyXs',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#FFFFFF',
			'#221B15',
		],
		season: 27,
		episode: 1,
	},
	{
		title: "Angler's Haven",
		img_src: 'https://www.twoinchbrush.com/images/painting348.png',
		img_src_index: 348,
		youtube_src: 'https://www.youtube.com/embed/XlwfcXZ0AIU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 27,
		episode: 2,
	},
	{
		title: 'Rustic Winter Woods',
		img_src: 'https://www.twoinchbrush.com/images/painting349.png',
		img_src_index: 349,
		youtube_src: 'https://www.youtube.com/embed/3q8Zi9480lw',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Sap Green',
			'Titanium White',
		],
		color_hex: ['#4E1500', '#FFEC00', '#FFB800', '#000000', '#0A3410', '#FFFFFF'],
		season: 27,
		episode: 3,
	},
	{
		title: 'Wilderness Falls',
		img_src: 'https://www.twoinchbrush.com/images/painting350.png',
		img_src_index: 350,
		youtube_src: 'https://www.youtube.com/embed/gxd0MPX8c6I',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 27,
		episode: 4,
	},
	{
		title: 'Winter at the Farm',
		img_src: 'https://www.twoinchbrush.com/images/painting351.png',
		img_src_index: 351,
		youtube_src: 'https://www.youtube.com/embed/LeIVNKnWz7o',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#FFFFFF', '#000000', '#021E44', '#FFFFFF', '#221B15'],
		season: 27,
		episode: 5,
	},
	{
		title: 'Daisies at Dawn',
		img_src: 'https://www.twoinchbrush.com/images/painting352.png',
		img_src_index: 352,
		youtube_src: 'https://www.youtube.com/embed/_kkZcIgocBM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 27,
		episode: 6,
	},
	{
		title: 'A Spectacular View',
		img_src: 'https://www.twoinchbrush.com/images/painting353.png',
		img_src_index: 353,
		youtube_src: 'https://www.youtube.com/embed/7R9HcaDT9P4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 27,
		episode: 7,
	},
	{
		title: 'Daybreak',
		img_src: 'https://www.twoinchbrush.com/images/painting354.png',
		img_src_index: 354,
		youtube_src: 'https://www.youtube.com/embed/crWDcTvDmec',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#FFEC00', '#5F2E1F', '#000000', '#021E44', '#FFFFFF', '#221B15'],
		season: 27,
		episode: 8,
	},
	{
		title: 'Island Paradise',
		img_src: 'https://www.twoinchbrush.com/images/painting355.png',
		img_src_index: 355,
		youtube_src: 'https://www.youtube.com/embed/Cg3XAVhAas0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 27,
		episode: 9,
	},
	{
		title: 'Sunlight in the Shadows',
		img_src: 'https://www.twoinchbrush.com/images/painting356.png',
		img_src_index: 356,
		youtube_src: 'https://www.youtube.com/embed/xgjQ0v2d9mE',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Liquid Clear',
			'Midnight Black',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: ['#4E1500', '#000000', '#FFFFFF', '#000000', '#FFFFFF', '#221B15', '#C79B00'],
		season: 27,
		episode: 10,
	},
	{
		title: 'Splendor of a Snowy Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting357.png',
		img_src_index: 357,
		youtube_src: 'https://www.youtube.com/embed/JdXCoxkOdwQ',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Liquid Black',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#5F2E1F',
			'#000000',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 27,
		episode: 11,
	},
	{
		title: 'Forest River',
		img_src: 'https://www.twoinchbrush.com/images/painting358.png',
		img_src_index: 358,
		youtube_src: 'https://www.youtube.com/embed/wrbGlR22K0Q',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 27,
		episode: 12,
	},
	{
		title: 'Golden Glow of Morning',
		img_src: 'https://www.twoinchbrush.com/images/painting359.png',
		img_src_index: 359,
		youtube_src: 'https://www.youtube.com/embed/qXElmiqzcI0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 27,
		episode: 13,
	},
	{
		title: "Fisherman's Trail",
		img_src: 'https://www.twoinchbrush.com/images/painting360.png',
		img_src_index: 360,
		youtube_src: 'https://www.youtube.com/embed/VnZEpic2UzU',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 28,
		episode: 1,
	},
	{
		title: 'A Warm Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting361.png',
		img_src_index: 361,
		youtube_src: 'https://www.youtube.com/embed/_TTdw3YnXuo',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 28,
		episode: 2,
	},
	{
		title: 'Under Pastel Skies',
		img_src: 'https://www.twoinchbrush.com/images/painting362.png',
		img_src_index: 362,
		youtube_src: 'https://www.youtube.com/embed/lzODyJS2ZIg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 28,
		episode: 3,
	},
	{
		title: 'Golden Rays of Sunshine',
		img_src: 'https://www.twoinchbrush.com/images/painting363.png',
		img_src_index: 363,
		youtube_src: 'https://www.youtube.com/embed/zxj3xLDNxo0',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Indian Yellow',
			'Liquid Clear',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFB800',
			'#FFFFFF',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
		],
		season: 28,
		episode: 4,
	},
	{
		title: 'The Magic of Fall',
		img_src: 'https://www.twoinchbrush.com/images/painting364.png',
		img_src_index: 364,
		youtube_src: 'https://www.youtube.com/embed/bSm3fmEyJ20',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 28,
		episode: 5,
	},
	{
		title: 'Glacier Lake',
		img_src: 'https://www.twoinchbrush.com/images/painting365.png',
		img_src_index: 365,
		youtube_src: 'https://www.youtube.com/embed/TohG7F8M3Ls',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 28,
		episode: 6,
	},
	{
		title: 'The Old Weathered Barn',
		img_src: 'https://www.twoinchbrush.com/images/painting366.png',
		img_src_index: 366,
		youtube_src: 'https://www.youtube.com/embed/NYUIIBFj0iQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 28,
		episode: 7,
	},
	{
		title: 'Deep Forest Falls',
		img_src: 'https://www.twoinchbrush.com/images/painting367.png',
		img_src_index: 367,
		youtube_src: 'https://www.youtube.com/embed/urHQRbRNuYI',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 28,
		episode: 8,
	},
	{
		title: "Winter's Grace",
		img_src: 'https://www.twoinchbrush.com/images/painting368.png',
		img_src_index: 368,
		youtube_src: 'https://www.youtube.com/embed/mxJ2On9wyvY',
		color_name: ['Midnight Black', 'Phthalo Blue', 'Prussian Blue', 'Titanium White'],
		color_hex: ['#000000', '#0C0040', '#021E44', '#FFFFFF'],
		season: 28,
		episode: 9,
	},
	{
		title: 'Splendor of Autumn',
		img_src: 'https://www.twoinchbrush.com/images/painting369.png',
		img_src_index: 369,
		youtube_src: 'https://www.youtube.com/embed/hEyR2FDp-00',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 28,
		episode: 10,
	},
	{
		title: 'Tranquil Seas',
		img_src: 'https://www.twoinchbrush.com/images/painting370.png',
		img_src_index: 370,
		youtube_src: 'https://www.youtube.com/embed/kN1DP_yqs-A',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 28,
		episode: 11,
	},
	{
		title: 'Mountain Serenity',
		img_src: 'https://www.twoinchbrush.com/images/painting371.png',
		img_src_index: 371,
		youtube_src: 'https://www.youtube.com/embed/wc_YVijYjT4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 28,
		episode: 12,
	},
	{
		title: 'Home Before Nightfall',
		img_src: 'https://www.twoinchbrush.com/images/painting372.png',
		img_src_index: 372,
		youtube_src: 'https://www.youtube.com/embed/22SiIDvyJeM',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#C79B00',
		],
		season: 28,
		episode: 13,
	},
	{
		title: 'Island in the Wilderness',
		img_src: 'https://www.twoinchbrush.com/images/painting373.png',
		img_src_index: 373,
		youtube_src: 'https://www.youtube.com/embed/lLWEXRAnQd0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 1,
	},
	{
		title: 'Autumn Oval',
		img_src: 'https://www.twoinchbrush.com/images/painting374.png',
		img_src_index: 374,
		youtube_src: 'https://www.youtube.com/embed/2XnIdinwot0',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 2,
	},
	{
		title: 'Seasonal Progression',
		img_src: 'https://www.twoinchbrush.com/images/painting375.png',
		img_src_index: 375,
		youtube_src: 'https://www.youtube.com/embed/T2G5waMfQ-g',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 3,
	},
	{
		title: 'Light at the Summit',
		img_src: 'https://www.twoinchbrush.com/images/painting376.png',
		img_src_index: 376,
		youtube_src: 'https://www.youtube.com/embed/HOdS-G8p1KE',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 4,
	},
	{
		title: 'Countryside Barn',
		img_src: 'https://www.twoinchbrush.com/images/painting377.png',
		img_src_index: 377,
		youtube_src: 'https://www.youtube.com/embed/G7Etn7QMeO4',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 5,
	},
	{
		title: 'Mountain Lake Falls',
		img_src: 'https://www.twoinchbrush.com/images/painting378.png',
		img_src_index: 378,
		youtube_src: 'https://www.youtube.com/embed/dNEp3hoHSDI',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 29,
		episode: 6,
	},
	{
		title: 'Cypress Creek',
		img_src: 'https://www.twoinchbrush.com/images/painting379.png',
		img_src_index: 379,
		youtube_src: 'https://www.youtube.com/embed/Tnb2cXKKuWM',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 7,
	},
	{
		title: "Trapper's Cabin",
		img_src: 'https://www.twoinchbrush.com/images/painting380.png',
		img_src_index: 380,
		youtube_src: 'https://www.youtube.com/embed/chhCkmp0RG8',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 8,
	},
	{
		title: 'Storm on the Horizon',
		img_src: 'https://www.twoinchbrush.com/images/painting381.png',
		img_src_index: 381,
		youtube_src: 'https://www.youtube.com/embed/pA_2paUhBAQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 9,
	},
	{
		title: "Pot O' Posies",
		img_src: 'https://www.twoinchbrush.com/images/painting382.png',
		img_src_index: 382,
		youtube_src: 'https://www.youtube.com/embed/2zv_S_uVoVQ',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
		],
		color_hex: ['#4E1500', '#000000', '#DB0000', '#000000', '#021E44', '#0A3410'],
		season: 29,
		episode: 10,
	},
	{
		title: 'A Perfect Winter Day',
		img_src: 'https://www.twoinchbrush.com/images/painting383.png',
		img_src_index: 383,
		youtube_src: 'https://www.youtube.com/embed/Io4fwhacpEs',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#021E44', '#FFFFFF', '#221B15'],
		season: 29,
		episode: 11,
	},
	{
		title: "Aurora's Dance",
		img_src: 'https://www.twoinchbrush.com/images/painting384.png',
		img_src_index: 384,
		youtube_src: 'https://www.youtube.com/embed/iRMsb9Vf7GM',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#FFFFFF',
			'#221B15',
		],
		season: 29,
		episode: 12,
	},
	{
		title: "Woodman's Retreat",
		img_src: 'https://www.twoinchbrush.com/images/painting385.png',
		img_src_index: 385,
		youtube_src: 'https://www.youtube.com/embed/ODrV0dfQcNs',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 29,
		episode: 13,
	},
	{
		title: 'Babbling Brook',
		img_src: 'https://www.twoinchbrush.com/images/painting386.png',
		img_src_index: 386,
		youtube_src: 'https://www.youtube.com/embed/ZHUdS0wEaKk',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 1,
	},
	{
		title: 'Woodgrain View',
		img_src: 'https://www.twoinchbrush.com/images/painting387.png',
		img_src_index: 387,
		youtube_src: 'https://www.youtube.com/embed/fcx1yUuSf3o',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 2,
	},
	{
		title: "Winter's Peace",
		img_src: 'https://www.twoinchbrush.com/images/painting388.png',
		img_src_index: 388,
		youtube_src: 'https://www.youtube.com/embed/Xzv3iiWi1Wo',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 3,
	},
	{
		title: 'Wilderness Trail',
		img_src: 'https://www.twoinchbrush.com/images/painting389.png',
		img_src_index: 389,
		youtube_src: 'https://www.youtube.com/embed/vGsW_6BCukU',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 4,
	},
	{
		title: 'A Copper Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting390.png',
		img_src_index: 390,
		youtube_src: 'https://www.youtube.com/embed/BSjee-ond7w',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 5,
	},
	{
		title: 'Misty Foothills',
		img_src: 'https://www.twoinchbrush.com/images/painting391.png',
		img_src_index: 391,
		youtube_src: 'https://www.youtube.com/embed/LEz4UVL7POE',
		color_name: [
			'Alizarin Crimson',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 6,
	},
	{
		title: 'Through the Window',
		img_src: 'https://www.twoinchbrush.com/images/painting392.png',
		img_src_index: 392,
		youtube_src: 'https://www.youtube.com/embed/SrN4A9rVXj0',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#021E44', '#FFFFFF', '#221B15'],
		season: 30,
		episode: 7,
	},
	{
		title: 'Home in the Valley',
		img_src: 'https://www.twoinchbrush.com/images/painting393.png',
		img_src_index: 393,
		youtube_src: 'https://www.youtube.com/embed/enutOy-nsZk',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 8,
	},
	{
		title: 'Mountains of Grace',
		img_src: 'https://www.twoinchbrush.com/images/painting394.png',
		img_src_index: 394,
		youtube_src: 'https://www.youtube.com/embed/nXlu_Q0sR7c',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 9,
	},
	{
		title: 'Seaside Harmony',
		img_src: 'https://www.twoinchbrush.com/images/painting395.png',
		img_src_index: 395,
		youtube_src: 'https://www.youtube.com/embed/CY6sGFs209E',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
		],
		season: 30,
		episode: 10,
	},
	{
		title: 'A Cold Spring Day',
		img_src: 'https://www.twoinchbrush.com/images/painting396.png',
		img_src_index: 396,
		youtube_src: 'https://www.youtube.com/embed/jq8bIbpW7DQ',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 11,
	},
	{
		title: "Evening's Glow",
		img_src: 'https://www.twoinchbrush.com/images/painting397.png',
		img_src_index: 397,
		youtube_src: 'https://www.youtube.com/embed/eTEKGOi6SVg',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 12,
	},
	{
		title: 'Blue Ridge Falls',
		img_src: 'https://www.twoinchbrush.com/images/painting398.png',
		img_src_index: 398,
		youtube_src: 'https://www.youtube.com/embed/fz0YjqtHW84',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 30,
		episode: 13,
	},
	{
		title: 'Reflections of Calm',
		img_src: 'https://www.twoinchbrush.com/images/painting399.png',
		img_src_index: 399,
		youtube_src: 'https://www.youtube.com/embed/kJFB6rH3z2A',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 1,
	},
	{
		title: 'Before the Snowfall',
		img_src: 'https://www.twoinchbrush.com/images/painting400.png',
		img_src_index: 400,
		youtube_src: 'https://www.youtube.com/embed/_MdMhQIOL1Y',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#021E44', '#FFFFFF', '#221B15'],
		season: 31,
		episode: 2,
	},
	{
		title: 'Winding Stream',
		img_src: 'https://www.twoinchbrush.com/images/painting401.png',
		img_src_index: 401,
		youtube_src: 'https://www.youtube.com/embed/QDwd4pMYyuo',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 3,
	},
	{
		title: 'Tranquility Cove',
		img_src: 'https://www.twoinchbrush.com/images/painting402.png',
		img_src_index: 402,
		youtube_src: 'https://www.youtube.com/embed/7t6ue0pEcNE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 4,
	},
	{
		title: 'Cabin in the Hollow',
		img_src: 'https://www.twoinchbrush.com/images/painting403.png',
		img_src_index: 403,
		youtube_src: 'https://www.youtube.com/embed/KYlM2zJnNWY',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#021E44', '#FFFFFF', '#221B15'],
		season: 31,
		episode: 5,
	},
	{
		title: 'View from Clear Creek',
		img_src: 'https://www.twoinchbrush.com/images/painting404.png',
		img_src_index: 404,
		youtube_src: 'https://www.youtube.com/embed/TLX1bmS8wBE',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 6,
	},
	{
		title: 'Bridge to Autumn',
		img_src: 'https://www.twoinchbrush.com/images/painting405.png',
		img_src_index: 405,
		youtube_src: 'https://www.youtube.com/embed/ReENCTH7MYI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 7,
	},
	{
		title: "Trail's End",
		img_src: 'https://www.twoinchbrush.com/images/painting406.png',
		img_src_index: 406,
		youtube_src: 'https://www.youtube.com/embed/XWQrP-WiLgc',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Dark Sienna',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#5F2E1F',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 8,
	},
	{
		title: 'Evergreen Valley',
		img_src: 'https://www.twoinchbrush.com/images/painting407.png',
		img_src_index: 407,
		youtube_src: 'https://www.youtube.com/embed/mEU0stNfkxI',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Black',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 9,
	},
	{
		title: 'Balmy Beach',
		img_src: 'https://www.twoinchbrush.com/images/painting408.png',
		img_src_index: 408,
		youtube_src: 'https://www.youtube.com/embed/kMgd6r6c4vE',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Liquid Clear',
			'Midnight Black',
			'Phthalo Blue',
			'Phthalo Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#FFFFFF',
			'#000000',
			'#0C0040',
			'#102E3C',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 10,
	},
	{
		title: 'Lake at the Ridge',
		img_src: 'https://www.twoinchbrush.com/images/painting409.png',
		img_src_index: 409,
		youtube_src: 'https://www.youtube.com/embed/8QWvzEQ69Kw',
		color_name: [
			'Alizarin Crimson',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#021E44',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 11,
	},
	{
		title: 'In the Midst of Winter',
		img_src: 'https://www.twoinchbrush.com/images/painting410.png',
		img_src_index: 410,
		youtube_src: 'https://www.youtube.com/embed/qx2IsmrCs3c',
		color_name: [
			'Alizarin Crimson',
			'Dark Sienna',
			'Midnight Black',
			'Phthalo Blue',
			'Prussian Blue',
			'Titanium White',
			'Van Dyke Brown',
		],
		color_hex: ['#4E1500', '#5F2E1F', '#000000', '#0C0040', '#021E44', '#FFFFFF', '#221B15'],
		season: 31,
		episode: 12,
	},
	{
		title: 'Wilderness Day',
		img_src: 'https://www.twoinchbrush.com/images/painting411.png',
		img_src_index: 411,
		youtube_src: 'https://www.youtube.com/embed/nJGCVFn57U8',
		color_name: [
			'Alizarin Crimson',
			'Black Gesso',
			'Bright Red',
			'Cadmium Yellow',
			'Dark Sienna',
			'Indian Yellow',
			'Midnight Black',
			'Phthalo Blue',
			'Sap Green',
			'Titanium White',
			'Van Dyke Brown',
			'Yellow Ochre',
		],
		color_hex: [
			'#4E1500',
			'#000000',
			'#DB0000',
			'#FFEC00',
			'#5F2E1F',
			'#FFB800',
			'#000000',
			'#0C0040',
			'#0A3410',
			'#FFFFFF',
			'#221B15',
			'#C79B00',
		],
		season: 31,
		episode: 13,
	},
];

export default BobRossPaintingsData;
